import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Input,
    Label,
    Badge,
    Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionBody,
    TabContent,
    TabPane,
    FormGroup,
    Form,
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import classnames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import MessageModal from "pages/AllCommonModal/MesssageModal/message-modal";
import DriverDetailsModal from "pages/AllCommonModal/DriverDetailsModal/driver-details-modal";
import PreScreeningModal from "pages/AllCommonModal/PreScreeningModal/pre-screening-modal";
import ImagePreviewModal from "pages/AllCommonModal/ImagePreviewModal/image-preview-modal";
import DrivingExperienceModal from "pages/AllCommonModal/DrivingExperienceModal/driving-experience-modal";
import FedexExistingDriverModal from "pages/AllCommonModal/FedexExistingDriverModal/fedex-existing-driver-modal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { resolveLoggedInUserTypeId } from "pages/Dashboard/RoleBasedDashboard";
import {
    getCallInfo,
    getCandidateDetailsForUsingCallDetails,
    fetchCommonCallStatusOptions,
    fetchCommonCallStatusMergeOptions,
    fetchCommonYesNoOptions,
    candidateAiRecruiterOptIn,
} from "model/CandidateModel";
import {
    getCandidateTestsForCallDetails,
    getFedexCandidateForCallDetails,
    getFadvDriverProfileImageForCallDetails,
    getFadvPackageOptionsForCallDetails,
    getFadvPanelForCallDetails,
    reloadFadvPackageStatusForCallDetails,
    reloadFadvProfileBackgroundImageForCallDetails,
    sendFadvDriverProfileApiForCallDetails,
    sendFadvPackageForCallDetails,
    sendFadvProfileOrderDetailsForCallDetails,
    sendFadvSendLinkForCallDetails,
    getCallDetailsAiTranscript,
    getCallDetailsConversation,
    getCallDetailsAiCallScheduled,
    submitCallDetailsCallStatus,
    updateCallDetailsEmail,
    updateCallDetailsFedexId,
    getCallDetailsUpperToolbar,
    getCallDetailsClientInfo,
    invokeCallDetailsPageActionPost,
    getFadvDriverProfileMetadataForCallDetails,
    uncheckExistingFedexDriverForCallDetails,
} from "model/CallModel";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import Loaders from "components/Common/Loaders";
import InlineEditableField from "components/Common/InlineEditableField";
import StatusMetadataBadge from "components/Common/StatusMetadataBadge";
import { commonReasonData, submitFilterData as submitMasterReasonsFilterData } from "model/ReasonModel";
import { mapCommonDropdownRecords } from "helpers/hireStatusInlineHelpers";
import {
    shouldShowCallNotesScheduleDateAndTimeFields,
    shouldShowCallNotesDrugTestAndDotCompletionDateFields,
    shouldShowCallNotesNotInterestedReasonDropdown,
    isCallStatusNotInterested,
    isCallStatusCompleted,
    isCallStatusEligible,
    mapReasonMasterFilterRowsToSelectOptions,
    isCallStatusRtrOrEligible,
} from "helpers/callDetailsCallNotesFieldRules";
import { phoneNumberShowFormat, urlEndPoint, downloadFileFromUrl, CALL_DETAILS_TAB_ORDER_SETTINGS_KEY, loadCallDetailsTabOrderFromStorage, saveCallDetailsTabOrderToStorage } from "helpers/GeneralHelper";
import { parseCandidateTestsApiResponse } from "helpers/callDetailsCandidateApplicationStatusTestPresentation";
import {
    buildCallDetailsClientInfoDisplaySections,
    buildCallDetailsClientIncentiveMetrics,
    parseCallDetailsClientInfoApiResponse,
} from "helpers/callDetailsClientInfoPresentation";
import CallDetailsCandidateApplicationStatusTestsSection from "pages/CallDetails/callDetailsCandidateApplicationStatusTestsSection";
import CallDetailsDriverProfileMetadataSection, {
    extractFadvDriverProfileMetadataRowsFromApiResponse,
} from "pages/CallDetails/callDetailsDriverProfileMetadataSection";
import CallDetailsAiCallScheduledModal, {
    extractAiCallScheduledRowsFromApiResponse,
} from "pages/CallDetails/callDetailsAiCallScheduledModal";
import CallDetailsAiCallRequestModal from "pages/CallDetails/callDetailsAiCallRequestModal";
import CallDetailsAiRecruiterOptOutModal from "pages/CallDetails/callDetailsAiRecruiterOptOutModal";
import CallDetailsBadFitResolutionModal from "pages/CallDetails/callDetailsBadFitResolutionModal";
import { triggerAiRecruiterCall } from "model/AiRecruiterLogModel";
import { usePermissionContext } from "libs/context/PermissionContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { saveUserSetting } from "model/UserSettingModel";
import { normalizeCandidateStatusMetadataValue } from "helpers/statusMetadataHelpers";


const displayText = (value) => {
    if (value === null || value === undefined) return "System";
    const item = String(value).trim();
    if (!item || item?.toLowerCase() === "null") return "System";
    return item;
};

const formatDateAdded = (date) => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("MM-DD-YYYY") : dayjs().format("MM-DD-YYYY");
};

const formatPersonalInfoCreatedAt = (raw) => {
    const parsed = dayjs(raw);
    return parsed.isValid() ? parsed.format("MM-DD-YYYY") : "N/A";
};

const CALL_NOTES_SCHEDULE_TIME_OPTIONS = Array.from({ length: 24 * 4 }, (_, index) => {
    const hours = Math.floor(index / 4);
    const minutes = (index % 4) * 15;
    const label = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    return { value: label, label };
});

const CALL_DETAILS_TABS = [
    { id: "1", label: "Client Info" },
    { id: "2", label: "Call Notes" },
    { id: "3", label: "AI Transcripts" },
];

const saveCallDetailsTabOrder = (tabOrder = []) => {
    const normalized = saveCallDetailsTabOrderToStorage(tabOrder);
    saveUserSetting({
        settingsKey: CALL_DETAILS_TAB_ORDER_SETTINGS_KEY,
        settingsValue: { tabOrder: normalized },
    });
    return normalized;
};

const resolveCallNotesScheduleTimeOption = (timePart) => {
    const time = String(timePart ?? "").trim();
    if (!time) return null;
    return (
        CALL_NOTES_SCHEDULE_TIME_OPTIONS.find((option) => option.value === time) ?? {
            value: time,
            label: time,
        }
    );
};

const parseCallNotesScheduledDateTimeValue = (scheduleDateTimeValue) => {
    const value = String(scheduleDateTimeValue ?? "").trim();
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.toDate() : null;
};

/** Send picker wall-clock time as-is (e.g. 22:15 → `2026-07-09T22:15:00.000Z`), without UTC offset shift. */
const buildCallNotesScheduledIsoFromDateAndTime = (scheduleDateTimeValue) => {
    const value = String(scheduleDateTimeValue ?? "").trim();
    if (!value) return null;

    const match = value.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}):(\d{2})/);
    if (match) {
        const [, datePart, hours, minutes] = match;
        return `${datePart}T${hours}:${minutes}:00.000Z`;
    }

    const parsed = dayjs(value);
    if (!parsed.isValid()) return null;
    return `${parsed.format("YYYY-MM-DD")}T${parsed.format("HH:mm")}:00.000Z`;
};

/** Date-only field (YYYY-MM-DD) → ISO at start of day for API. */
const buildCallNotesDateOnlyIsoFromDateInput = (dateOnlyValue) => {
    const value = String(dateOnlyValue ?? "").trim();
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.startOf("day").toISOString() : null;
};

const formatCallActivityDateOnly = (date) => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("MM-DD-YYYY") : "N/A";
};

const statusBadgeColor = (status) => {
    const s = String(status || "").toLowerCase();
    if (s === "active") return "success";
    if (s === "inactive" || s === "deactivated") return "secondary";
    return "warning";
};

const formatCallActivityDateTime = (date) => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("h:mm A MM-DD-YYYY") : "N/A";
};

const callStatusTypeBadgeColor = (callStatusType) => {
    const type = String(callStatusType || "").toLowerCase().trim();
    if (['complete', 'completed', 'eligible'].includes(type)) return "success";
    if (['schedule', 'scheduled', 'vm'].includes(type)) return "primary";
    if (['fadv send', 'rtr internal', 'in progress'].includes(type)) return "info";
    if (['cancel', 'cancelled', 'in-eligible for hire', 'rejected', 'not ordered', 'Ineligible', 'ineligible', 'In Eligible'].includes(type)) return "danger";
    if (['pending', 'follow-up', 'followup'].includes(type)) return "warning";
    return "secondary";
};

const humanizeCallStatusType = (callStatusType) => {
    const raw = String(callStatusType ?? "").trim();
    if (!raw) return "—";
    return raw
        .replace(/[-_]/g, " ")
        .split(/\s+/)
        .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : ""))
        .join(" ");
};

const extractFadvPanelRecordFromApiResponse = (apiResponse) => {
    const payload = apiResponse?.data ?? apiResponse;
    if (!payload || typeof payload !== "object") return null;
    return payload;
};

/** Map FADV `sendFadvLink` panel string to a `common/yes-no` option `value`. */
const resolveSendFadvLinkSelectValueFromPanel = (sendFadvLinkRaw, options) => {
    const opts = Array.isArray(options) ? options : [];
    if (!opts.length) return "";
    const normalized = String(sendFadvLinkRaw ?? "").trim().toLowerCase();
    if (!normalized || normalized === "null") {
        const noOpt =
            opts.find((o) => String(o.value).toLowerCase() === "no") ||
            opts.find((o) => /^no\b/i.test(String(o.label ?? "")));
        return String((noOpt ?? opts[0])?.value ?? "");
    }
    const byValue = opts.find((o) => String(o.value).toLowerCase() === normalized);
    if (byValue) return byValue.value;
    const byLabel = opts.find((o) => String(o.label ?? "").trim().toLowerCase() === normalized);
    if (byLabel) return byLabel.value;
    if (["yes", "true", "1"].includes(normalized)) {
        const yes =
            opts.find((o) => String(o.value).toLowerCase() === "yes") ||
            opts.find((o) => /^yes\b/i.test(String(o.label ?? "")));
        if (yes) return yes.value;
    }
    if (["no", "false", "0"].includes(normalized)) {
        const no =
            opts.find((o) => String(o.value).toLowerCase() === "no") ||
            opts.find((o) => /^no\b/i.test(String(o.label ?? "")));
        if (no) return no.value;
    }
    return String(opts[0]?.value ?? "");
};

const extractFadvPackageOptionsFromApiResponse = (apiResponse) => {
    const payload = apiResponse?.data ?? apiResponse;
    if (!payload) return [];
    const list = Array.isArray(payload) ? payload : Array.isArray(payload?.data) ? payload.data : [];
    return list.filter((row) => row && typeof row === "object");
};

const pickFirstNonEmptyString = (...candidates) => {
    for (const candt of candidates) {
        const data = String(candt ?? "").trim();
        if (data && data.toLowerCase() !== "null") return data;
    }
    return "";
};

/** Personal Information read-only values — empty / null → `N/A`. */
const personalInfoFieldOrNa = (...candidates) => {
    const value = pickFirstNonEmptyString(...candidates);
    return value || "N/A";
};

/** Personal Information Reactstrap badges (solid bg-* colors). */
const PERSONAL_INFO_VALUE_BADGE_CLASS =
    "badge badge-padding align-middle border-radius-zero";

/**
 * StatusMetadataBadge pills (Order Status, Update Send, Job Acceptance).
 * Default theme keeps badge-padding look; Advanced styles `.cd-personal-status-badge`.
 * `common-table-status-badge` avoids Primary font-color forcing white on light pills.
 */
const PERSONAL_INFO_STATUS_METADATA_BADGE_CLASS =
    "badge badge-padding align-middle border-radius-zero common-table-status-badge cd-personal-status-badge";

/** `jobName` — info pill badge (same design as before on Personal Information). */
const renderPersonalInfoJobNameBadge = (...candidates) => {
    const value = pickFirstNonEmptyString(...candidates);
    if (!value) return "N/A";
    return (
        <Badge
            color="info"
            pill
            className={PERSONAL_INFO_VALUE_BADGE_CLASS}
        >
            {value}
        </Badge>
    );
};

/** Client AI recruiter flag from toolbar — `toolbarData?.clientIsAiRecruiterEnabled`. */
const renderPersonalInfoClientAiRecruiterBadge = (
    clientIsAiRecruiterEnabled,
    { matchCandidateStatusBadge = false } = {}
) => {
    if (
        clientIsAiRecruiterEnabled === null ||
        clientIsAiRecruiterEnabled === undefined
    ) {
        return null;
    }

    const isEnabled = Boolean(clientIsAiRecruiterEnabled);
    const badge = (
        <Badge
            color={isEnabled ? "success" : "secondary"}
            pill={!matchCandidateStatusBadge}
            className={
                matchCandidateStatusBadge
                    ? "badge-padding text-capitalize ms-0 align-middle"
                    : PERSONAL_INFO_VALUE_BADGE_CLASS
            }
            title={
                isEnabled
                    ? "This client has AI Recruiter enabled"
                    : "This client does not have AI Recruiter enabled"
            }
        >
            <i
                className={`mdi ${isEnabled ? "mdi-robot" : "mdi-robot-off-outline"} me-1`}
                aria-hidden
            />
            {isEnabled ? "AI Recruiter" : "No AI"}
        </Badge>
    );

    if (matchCandidateStatusBadge) {
        return <span className="cd-candidate-name">{badge}</span>;
    }

    return badge;
};

const renderPersonalInfoCandidateAiRecruiterBadge = (
    clientIsAiRecruiterEnabled,
    isAIRecruiterOptedIn,
    { matchCandidateStatusBadge = false } = {}
) => {
    if (
        clientIsAiRecruiterEnabled === null ||
        clientIsAiRecruiterEnabled === undefined ||
        isAIRecruiterOptedIn === null ||
        isAIRecruiterOptedIn === undefined
    ) {
        return null;
    }

    const isEnabled = Boolean(clientIsAiRecruiterEnabled);
    const isOptedIn = Boolean(isAIRecruiterOptedIn);
    const isOnAi = isEnabled && isOptedIn;
    const badge = (
        <Badge
            color={isOnAi ? "success" : "secondary"}
            pill={!matchCandidateStatusBadge}
            className={
                matchCandidateStatusBadge
                    ? "badge-padding text-capitalize ms-0 align-middle"
                    : PERSONAL_INFO_VALUE_BADGE_CLASS
            }
            title={
                isOnAi
                    ? "Candidate is on AI Recruiter"
                    : "Candidate is off AI Recruiter"
            }
        >
            <i
                className={`mdi ${isOnAi ? "mdi-robot" : "mdi-robot-off-outline"} me-1`}
                aria-hidden
            />
            {isOnAi ? "On AI" : "Off AI"}
        </Badge>
    );

    if (matchCandidateStatusBadge) {
        return <span className="cd-candidate-name">{badge}</span>;
    }

    return badge;
};

/**
 * Candidate AI Recruiter opt-in button — `candidateDetails.isAIRecruiterOptedIn`.
 * false → "Resume" (opt in); true → "Not Resume" (opt out).
 * Shown after `cd-client-incentive-metrics` in the personal info header.
 */
const renderPersonalInfoAiRecruiterOptInPill = ({
    isAIRecruiterOptedIn,
    onClick,
    disabled = false,
}) => {
    if (isAIRecruiterOptedIn === null || isAIRecruiterOptedIn === undefined) {
        return null;
    }

    const isOptedIn = Boolean(isAIRecruiterOptedIn);

    return (
        <Button
            type="button"
            color={isOptedIn ? "danger" : "success"}
            className="cd-ai-recruiter-opt-btn"
            title={
                isOptedIn
                    ? "Click to opt out of AI Recruiter (Withdraw)"
                    : "Click to resume AI Recruiter"
            }
            onClick={onClick}
            disabled={disabled}
        >
            <i
                className={`mdi ${isOptedIn ? "mdi-robot-off-outline" : "mdi-robot"}`}
                aria-hidden
            />
            {isOptedIn ? "Withdraw" : "Resume"}
        </Button>
    );
};

/** Job Acceptance — API `jobAcceptanceHtml` or `jobAcceptanceLabelCss` + label, else metadata badge. */
const renderPersonalInfoJobAcceptanceBadge = (record) => {
    if (!record || typeof record !== "object") return "N/A";

    const html = pickFirstNonEmptyString(record.jobAcceptanceHtml, record.JobAcceptanceHtml);
    if (html) {
        return (
            <span
                className="cd-personal-info-job-acceptance-html"
                dangerouslySetInnerHTML={{ __html: html }}
            />
        );
    }

    const label = pickFirstNonEmptyString(record.jobAcceptance, record.JobAcceptance);
    const labelCss = pickFirstNonEmptyString(
        record.jobAcceptanceLabelCss,
        record.JobAcceptanceLabelCss
    );

    if (label) {
        if (labelCss) {
            return <span className={labelCss}>{label}</span>;
        }
        return (
            <StatusMetadataBadge
                accessor="jobAcceptance"
                pageName="call-details"
                value={label}
                className={PERSONAL_INFO_STATUS_METADATA_BADGE_CLASS}
                emptyPlaceholder="N/A"
            />
        );
    }

    return "N/A";
};

/** Update Send — candidate-by-id `updateSend` Yes/No badge. */
const renderPersonalInfoUpdateSend = (record) => {
    if (!record || typeof record !== "object") return "N/A";

    const updateSendRaw =
        record.updateSend !== undefined && record.updateSend !== null
            ? record.updateSend
            : record.UpdateSend;
    const updateSendValue = normalizeCandidateStatusMetadataValue(
        "updateSend",
        updateSendRaw
    );

    if (
        updateSendValue === null ||
        updateSendValue === undefined ||
        String(updateSendValue).trim() === ""
    ) {
        return "N/A";
    }

    return (
        <StatusMetadataBadge
            accessor="updateSend"
            pageName="call-details"
            value={updateSendValue}
            className={PERSONAL_INFO_STATUS_METADATA_BADGE_CLASS}
            emptyPlaceholder="N/A"
        />
    );
};

const resolveDriverProfileImageHref = (record) => {
    if (!record || typeof record !== "object") return "";
    const path = pickFirstNonEmptyString(
        record.imageUrl,
        record.image,
        record.url,
        record.profileImageUrl,
        record.backgroundImageUrl,
        record.driverProfileImage,
        record.imageLink
    );
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path;
    const base = String(process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");
    if (!base) return path;
    return path.startsWith("/") ? `${base}${path}` : `${base}/${path}`;
};

const resolveDriverProfileLastUpdatedLabel = (record) => {
    if (!record || typeof record !== "object") return "N/A";
    const raw = pickFirstNonEmptyString(
        record.lastUpdatedTime,
        record.lastUpdatedAt,
        record.updatedAt,
        record.modifiedAt,
        record.lastUpdated,
        record.updateAt,
        record.fadvLastUpdatedTime
    );
    if (!raw) return "N/A";
    // API may already return a display string (e.g. "05-Jul-2026 05:43 PM") that dayjs won't parse.
    const parsed = dayjs(raw);
    return parsed.isValid() ? parsed.format("h:mm A MM-DD-YYYY") : raw;
};

const selectZIndexStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
};

const CallNotesScheduleCustomTimeInput = ({ value, onChange }) => (
    <Select
        options={CALL_NOTES_SCHEDULE_TIME_OPTIONS}
        className="select2-selection"
        placeholder="Select time"
        isSearchable
        value={resolveCallNotesScheduleTimeOption(value)}
        onChange={(selectedOption) => onChange(selectedOption?.value ?? "")}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        styles={selectZIndexStyles}
        menuPosition="fixed"
    />
);

const getSelectedOption = (options, value) =>
    (Array.isArray(options) ? options : []).find(
        (opt) => String(opt?.value ?? "") === String(value ?? "")
    ) || null;

const FADV_DRIVER_PROFILE_METADATA_ACCORDION_ID = "fadv-driver-metadata";

const ORDER_STATUSES_SHOWING_DRIVER_DETAILS_SECTION = new Set([
    "eligible",
    "road test ready",
    "needs further review"
]);

const normalizeOrderStatusForDriverDetailsGate = (rawOrderStatus) =>
    String(rawOrderStatus ?? "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");

/** Driver Details FADV row — only when order status is Eligible or Road Test Ready. */
const isOrderStatusEligibleForDriverDetailsSection = (rawOrderStatus) =>
    ORDER_STATUSES_SHOWING_DRIVER_DETAILS_SECTION.has(
        normalizeOrderStatusForDriverDetailsGate(rawOrderStatus)
    );

const sortCallActivitiesNewestFirst = (list = []) =>
    [...list].sort((a, b) => {
        const ta = dayjs(a?.callDate ?? a?.createdDate).valueOf();
        const tb = dayjs(b?.callDate ?? b?.createdDate).valueOf();
        return tb - ta;
    });

const parseCallActivitiesList = (response) => {
    const raw = response?.data?.currentClientActivities ?? response;
    const list = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
    return sortCallActivitiesNewestFirst(list);
};

const parseOtherClientActivitiesGroups = (response) => {
    const raw =
        response?.data?.otherClientActivities ??
        response?.otherClientActivities ??
        [];
    if (!Array.isArray(raw)) return [];

    return raw
        .map((group = {}) => ({
            clientId: String(group?.clientId ?? "").trim(),
            clientName: String(group?.clientName ?? group?.client ?? "").trim() || "Client",
            activities: sortCallActivitiesNewestFirst(
                Array.isArray(group?.activities) ? group.activities : []
            ),
        }))
        .filter((group) => group.clientId || group.clientName || group.activities.length > 0);
};

const defaultChatUserAvatarSrc = `${process.env.PUBLIC_URL || ""}/no-image.png`;

const hasAiCallTranscriptId = (callActivityRecord) => {
    const id = String(callActivityRecord?.aiCallTranscriptId ?? "").trim();
    return Boolean(id && id.toLowerCase() !== "null");
};

const getTranscriptTextFromRow = (row = {}) => {
    const v = row?.callTranscript ?? row?.calltranscript ?? row?.transcript ?? "";
    if (v == null) return "";
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v, null, 2);
    } catch {
        return String(v);
    }
};

const mapTranscriptMessageRole = (roleRaw) => {
    const role = String(roleRaw ?? "")
        .trim()
        .toLowerCase();
    if (!role) return "bot";
    if (
        role === "user" ||
        role === "candidate" ||
        role === "applicant" ||
        role.includes("candidate")
    ) {
        return "user";
    }
    return "bot";
};

const getTranscriptSenderLabel = (roleRaw, mappedRole) => {
    const original = String(roleRaw ?? "").trim();
    if (original) return original;
    return mappedRole === "user" ? "Candidate" : "AI Recruiter";
};

const parseTranscriptMessagesFromRow = (row = {}) => {
    const raw =
        row?.callTranscript ?? row?.calltranscript ?? row?.transcript ?? row?.data;
    if (raw == null || raw === "") return [];

    let parsed = raw;
    if (typeof raw === "string") {
        try {
            parsed = JSON.parse(raw);
        } catch {
            return [];
        }
    }

    const list = Array.isArray(parsed)
        ? parsed
        : parsed?.messages ?? parsed?.data ?? parsed?.records ?? [];
    if (!Array.isArray(list)) return [];

    return list
        .map((item = {}, idx) => {
            const roleRaw = item?.role ?? item?.sender ?? item?.from ?? "AI Recruiter";
            const message = String(
                item?.message ?? item?.text ?? item?.content ?? ""
            ).trim();
            if (!message) return null;
            const mappedRole = mapTranscriptMessageRole(roleRaw);
            return {
                id: item?.id ?? `${mappedRole}-${idx}`,
                role: mappedRole,
                senderLabel: getTranscriptSenderLabel(roleRaw, mappedRole),
                message,
            };
        })
        .filter(Boolean);
};

const formatConversationMessageTime = (raw) => {
    const value = String(raw ?? "").trim();
    if (!value) return "";
    const parsed = dayjs(value);
    if (parsed.isValid()) {
        return parsed.format("h:mm A MM-DD-YYYY");
    }
    return value;
};

const mapConversationMessageSender = (item = {}) => {
    const sentBy = String(item?.sentBy ?? "").trim().toLowerCase();
    const conversationType = String(item?.conversationType ?? "").trim().toLowerCase();
    const displayFrom = String(item?.displayFrom ?? "").trim().toLowerCase();

    if (
        displayFrom.includes("candidate") ||
        conversationType === "candidate" ||
        sentBy === "candidate"
    ) {
        return "user";
    }
    return "bot";
};

const resolveConversationDisplayFrom = (item = {}, sender = "bot") => {
    const label = String(item?.displayFrom ?? "").trim();
    if (label) return label;
    if (sender === "user") return "Candidate";
    const conversationType = String(item?.conversationType ?? "").trim();
    if (conversationType) {
        return conversationType.charAt(0).toUpperCase() + conversationType.slice(1).toLowerCase();
    }
    return "Recruiter";
};

const parseCallDetailsConversationApiResponse = (apiResponse) => {
    const payload = apiResponse?.data ?? apiResponse;
    if (!payload || typeof payload !== "object") {
        return {
            canAccessConversation: false,
            candidateFirstName: "",
            candidateClientId: "",
            messages: [],
            templates: [],
        };
    }

    const templates = (Array.isArray(payload?.templates) ? payload.templates : [])
        .map((item = {}) => {
            const value = String(item?.id ?? item?._id ?? "").trim();
            const label = String(item?.label ?? item?.name ?? item?.title ?? value).trim();
            if (!value) return null;
            return { value, label: label || value };
        })
        .filter(Boolean);

    const list = Array.isArray(payload?.messages) ? payload.messages : [];
    const messages = list
        .map((item = {}, idx) => {
            const text = String(
                item?.message ?? item?.text ?? item?.content ?? item?.body ?? ""
            ).trim();
            if (!text) return null;

            const sender = mapConversationMessageSender(item);
            const sentDateRelative = String(item?.sentDateRelative ?? "").trim();
            const time = sentDateRelative || formatConversationMessageTime(item?.sentDate);
            const displayFrom = resolveConversationDisplayFrom(item, sender);

            return {
                id: item?.id ?? `conversation-${idx}`,
                sender,
                text,
                time,
                displayFrom,
                conversationType: String(item?.conversationType ?? "").trim(),
                read: Boolean(item?.read ?? item?.isRead),
            };
        })
        .filter(Boolean);

    return {
        canAccessConversation: payload?.canAccessConversation !== false,
        candidateFirstName: String(payload?.candidateFirstName ?? "").trim(),
        candidateClientId: String(payload?.candidateClientId ?? "").trim(),
        messages,
        templates,
    };
};

const normalizeCallDetailsTranscriptApiResponse = (apiResponse) => {
    const payload = apiResponse?.data ?? apiResponse;
    if (!payload) return {};
    if (typeof payload === "string") return { callTranscript: payload };
    if (Array.isArray(payload)) return { callTranscript: payload };

    if (typeof payload === "object") {
        if (payload.isRaw && payload.rawData != null) {
            const rawData = payload.rawData;
            return {
                callTranscript:
                    typeof rawData === "string" ? rawData : JSON.stringify(rawData, null, 2),
                isRaw: true,
            };
        }

        const messages = Array.isArray(payload.data)
            ? payload.data
            : Array.isArray(payload.messages)
                ? payload.messages
                : null;
        if (messages?.length) {
            return {
                callTranscript: messages,
                transcriptId: payload.transcriptId,
            };
        }

        return payload;
    }

    return {};
};

const getCallActivityAccordionTargetId = (callActivityRecord) =>
    String(callActivityRecord?.id ?? "").trim() ||
    `idx-${callActivityRecord?.candidateClientId}-${callActivityRecord?.callDate}`;

/** Screenshot pattern: bold Label: muted value on one line */
const InfoField = ({ label, children, className }) => (
    <div className={classnames("cd-field-line", className)}>
        <span className="cd-field-label">{label}:</span>{" "}
        <span className="cd-field-value">{children}</span>
    </div>
);

const isCopyablePersonalInfoValue = (value) => {
    const text = String(value ?? "").trim();
    if (!text) return false;
    const lower = text.toLowerCase();
    return text !== "—" && lower !== "n/a" && lower !== "null" && lower !== "system";
};

const copyPersonalInfoValue = async (value) => {
    const text = String(value ?? "").trim();
    if (!isCopyablePersonalInfoValue(text)) return null;
    try {
        await navigator.clipboard.writeText(text);
        return text;
    } catch {
        return null;
    }
};

/** Click-to-copy wrapper for Personal Information fields (same Copied tooltip as bundle copy). */
const CopyablePersonalInfoValue = ({ value, toastLabel, children, className }) => {
    const [copiedTooltipMessage, setCopiedTooltipMessage] = useState("");
    const tooltipTimeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (tooltipTimeoutRef.current) {
                clearTimeout(tooltipTimeoutRef.current);
            }
        };
    }, []);

    const handleCopy = (event) => {
        event?.stopPropagation?.();
        void (async () => {
            const text = await copyPersonalInfoValue(value);
            if (!text) return;
            if (tooltipTimeoutRef.current) {
                clearTimeout(tooltipTimeoutRef.current);
            }
            setCopiedTooltipMessage(`Copied ${toastLabel} "${text}"`);
            tooltipTimeoutRef.current = setTimeout(() => {
                setCopiedTooltipMessage("");
                tooltipTimeoutRef.current = null;
            }, 2500);
        })();
    };

    return (
        <span
            className={classnames(
                "cd-personal-copy-wrap cd-personal-copy-wrap--inline",
                { "cd-personal-copy-wrap--active": Boolean(copiedTooltipMessage) },
                className
            )}
        >
            {copiedTooltipMessage ? (
                <span
                    className="cd-personal-copy-tooltip"
                    role="status"
                    aria-live="polite"
                >
                    {copiedTooltipMessage}
                </span>
            ) : null}
            <span
                className="cursor-pointer"
                onClick={handleCopy}
                onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleCopy(event);
                    }
                }}
                role="button"
                tabIndex={0}
                title={`Click to copy ${toastLabel}`}
            >
                {children}
            </span>
        </span>
    );
};

const normalizeCallStatusKey = (callStatusType) =>
    String(callStatusType || "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, " ");

const isScheduleCallStatus = (callStatusType) => {
    const t = normalizeCallStatusKey(callStatusType);
    return t === "schedule" || t === "scheduled";
};

const isVmCallStatus = (callStatusType) => {
    const t = normalizeCallStatusKey(callStatusType);
    const compact = t.replace(/\s+/g, "");
    return t === "vm" || compact === "vm" || t.includes("voicemail");
};

const isFadvSendCallStatus = (callStatusType) => {
    const t = normalizeCallStatusKey(callStatusType).replace(/[-_]/g, " ");
    if (t === "fadv send" || t === "fadvsend") return true;
    return t.includes("fadv") && t.includes("send");
};

const isCompletedCallStatus = (callStatusType) => {
    const t = normalizeCallStatusKey(callStatusType);
    return t === "complete" || t === "completed";
};

const drugTestAndDotCompletionDateFromCallActivity = (callActivityRecord) =>
    callActivityRecord?.drugTestAndDotCompletionDate ?? null;

const scheduleCandidateDateTime = (callActivityRecord) =>
    callActivityRecord?.scheduleDateCandidateDisplay ??
    callActivityRecord?.scheduleDateCandidate ??
    callActivityRecord?.scheduleDateAndTime ??
    callActivityRecord?.scheduleDateTime ??
    callActivityRecord?.candidateScheduleDateTime ??
    callActivityRecord?.candidateSchedule ??
    callActivityRecord?.schedule_date_and_time ??
    callActivityRecord?.schedule_date_time ??
    null;

const scheduleCallerDateTime = (callActivityRecord) =>
    callActivityRecord?.scheduleDateCallerDisplay ??
    callActivityRecord?.scheduleDateCaller ??
    callActivityRecord?.callerDateTime ??
    callActivityRecord?.callerScheduleDateTime ??
    callActivityRecord?.callerDate ??
    callActivityRecord?.caller_date_time ??
    null;

const formatBoolTrueFalse = (v) => {
    if (v === true || v === 1) return "True";
    if (v === false || v === 0) return "False";
    const s = String(v ?? "").trim().toLowerCase();
    if (s === "true" || s === "yes" || s === "1") return "True";
    if (s === "false" || s === "no" || s === "0") return "False";
    return "";
};

/** Personal Information → Quota: "Driving Experience" initial checked state from API. */
const resolveDrivingExperienceDefaultChecked = (candidateDetails) => {
    if (!candidateDetails || typeof candidateDetails !== "object") return false;
    const raw =
        candidateDetails.drivingExperience ??
        candidateDetails.driving_experience ??
        candidateDetails.hasDrivingExperience ??
        candidateDetails.has_driving_experience ??
        candidateDetails.isDriverExperience ??
        candidateDetails.is_driver_experience ??
        candidateDetails.driverExperience;
    if (raw === true || raw === 1) return true;
    if (raw === false || raw === 0) return false;
    const s = String(raw ?? "").trim().toLowerCase();
    return s === "true" || s === "yes" || s === "1";
};

/** Personal Information → Quota: "Is Existing FedEx Driver" initial checked state from API. */
const resolveIsFedexDriverDefaultChecked = (candidateDetails) => {
    if (!candidateDetails || typeof candidateDetails !== "object") return false;
    const raw =
        candidateDetails.isFedexDriver ??
        candidateDetails.isFedexdriver ??
        candidateDetails.is_fedex_driver ??
        candidateDetails.fedexDriver ??
        candidateDetails.fedex_driver;
    if (raw === true || raw === 1) return true;
    if (raw === false || raw === 0) return false;
    const s = String(raw ?? "").trim().toLowerCase();
    return s === "true" || s === "yes" || s === "1";
};

/** Call Info accordion — notes may contain HTML from the API. */
const CallActivityNotesField = ({ callNotes }) => {
    const html = callNotes != null ? String(callNotes).trim() : "";
    return (
        <div className="cd-field-line">
            <span className="cd-field-label">Notes:</span>
            <div className="cd-field-value d-block w-100 mt-1">
                {html ? (
                    <div
                        className="cd-call-notes-html text-break"
                        dangerouslySetInnerHTML={{ __html: html }}
                    />
                ) : (
                    "—"
                )}
            </div>
        </div>
    );
};

const confirmCallDetailsApplicationStatusSend = async (message = "Are you sure you want to send?") => {
    const result = await Swal.fire({
        title: "Confirm",
        text: message,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        reverseButtons: true,
    });
    return Boolean(result?.isConfirmed);
};

const fadvLinkSendResolved = (callActivityRecord) => {
    const direct =
        callActivityRecord?.fadvLinkSend ??
        callActivityRecord?.fadvLinkSent ??
        callActivityRecord?.isFadvLinkSend ??
        callActivityRecord?.fadVLinkSend ??
        callActivityRecord?.fadvSend ??
        callActivityRecord?.fadv_link_send;
    const word = formatBoolTrueFalse(direct);
    if (word) return word;
    const callNotesTextLowercase = String(callActivityRecord?.callNotes ?? "").trim().toLowerCase();
    if (callNotesTextLowercase.includes("true")) return "True";
    if (callNotesTextLowercase.includes("false")) return "False";
    return null;
};

const renderScheduleOrVmCallActivityBody = (callActivityRecord, headingLabel) => {
    const cand = formatCallActivityDateTime(scheduleCandidateDateTime(callActivityRecord));
    const caller = formatCallActivityDateTime(scheduleCallerDateTime(callActivityRecord));
    const activityNotesText =
        callActivityRecord?.callNotes != null && String(callActivityRecord.callNotes).trim() !== ""
            ? String(callActivityRecord.callNotes).trim()
            : "";

    return (
        <div className="cd-call-activity-body small">
            <p className="mb-0 text-break">
                <span className="fw-semibold cd-field-line cd-field-label">{headingLabel}</span>
                <span className="cd-field-line cd-field-label">
                    {" "}
                    : Candidate{" "}
                    <span className="cd-field-line cd-field-value">- {cand}</span>
                </span>
                <span className="ms-4 ps-1 cd-field-line cd-field-label">
                    Caller - <span className="cd-field-line cd-field-value">{caller}</span>
                </span>
            </p>
            {activityNotesText ? (
                <div
                    className="mb-0 mt-2 text-break cd-field-line cd-field-label cd-call-notes-html"
                    dangerouslySetInnerHTML={{ __html: activityNotesText }}
                />
            ) : null}
        </div>
    );
};

const renderCallActivityBody = (callActivityRecord) => {
    const status = callActivityRecord?.callStatusType;

    if (isScheduleCallStatus(status)) {
        return renderScheduleOrVmCallActivityBody(callActivityRecord, "Schedule");
    }

    if (isVmCallStatus(status)) {
        return renderScheduleOrVmCallActivityBody(callActivityRecord, "VM");
    }

    if (isFadvSendCallStatus(status)) {
        const resolved = fadvLinkSendResolved(callActivityRecord);
        const display = resolved ?? displayText(callActivityRecord?.callNotes);
        return (
            <div className="cd-call-activity-body small">
                <p className="mb-0 text-break cd-field-line cd-field-label">Fadv Link Send : <span className="cd-field-line cd-field-value">{display}</span></p>
            </div>
        );
    }

    if (isCompletedCallStatus(status)) {
        const completionDateRaw =
            drugTestAndDotCompletionDateFromCallActivity(callActivityRecord);
        return (
            <div className="cd-call-activity-body small">
                {/* <InfoField label="Drug Test and DOT Completion Date">
                    {completionDateRaw != null && String(completionDateRaw).trim() !== ""
                        ? formatCallActivityDateOnly(completionDateRaw)
                        : "—"}
                </InfoField> */}
                <CallActivityNotesField callNotes={callActivityRecord?.callNotes} />
            </div>
        );
    }

    return (
        <div className="cd-call-activity-body small">
            <CallActivityNotesField callNotes={callActivityRecord?.callNotes} />
            {callActivityRecord?.followUpDate != null &&
                String(callActivityRecord.followUpDate).trim() !== "" ? (
                <InfoField label="Follow-up">
                    {formatCallActivityDateTime(callActivityRecord.followUpDate)}
                </InfoField>
            ) : null}
            {callActivityRecord?.callDuration != null &&
                String(callActivityRecord.callDuration).trim() !== "" ? (
                <InfoField label="Duration">
                    {displayText(callActivityRecord.callDuration)}
                </InfoField>
            ) : null}
            {/* <InfoField label="Completed">
                {callActivityRecord?.isCompleted ? "Yes" : "No"}
            </InfoField> */}
        </div>
    );
};

const renderCallActivitiesAccordion = ({
    activities = [],
    accordionOpen = [],
    toggleAccordion,
    idPrefix = "",
    emptyMessage = "No call activity yet.",
}) => {
    if (!activities.length) {
        return <p className="text-muted small mb-2">{emptyMessage}</p>;
    }

    return (
        <Accordion open={accordionOpen} toggle={toggleAccordion}>
            {activities.map((callActivityRecord) => {
                const baseTargetId = getCallActivityAccordionTargetId(callActivityRecord);
                const callActivityAccordionTargetId = idPrefix
                    ? `${idPrefix}-${baseTargetId}`
                    : baseTargetId;
                return (
                    <AccordionItem key={callActivityAccordionTargetId} className="mt-1">
                        <AccordionHeader targetId={callActivityAccordionTargetId}>
                            <div className="d-flex flex-wrap align-items-center gap-2">
                                <strong>
                                    {formatCallActivityDateTime(callActivityRecord?.callDate)}
                                </strong>
                                <Badge
                                    color={callStatusTypeBadgeColor(
                                        callActivityRecord?.callStatusType
                                    )}
                                    className="badge-padding text-capitalize"
                                >
                                    {humanizeCallStatusType(callActivityRecord?.callStatusType)}
                                </Badge>
                                <span className="text-muted">Submitted By</span>
                                <span>{displayText(callActivityRecord?.callByName)}</span>
                            </div>
                        </AccordionHeader>
                        <AccordionBody accordionId={callActivityAccordionTargetId}>
                            {renderCallActivityBody(callActivityRecord)}
                        </AccordionBody>
                    </AccordionItem>
                );
            })}
        </Accordion>
    );
};

const CallDetails = () => {
    const { id, openDriverDetails } = useParams();
    const navigate = useNavigate();
    const { permissionData } = usePermissionContext() || {};
    const shouldAutoOpenDriverDetailsModal =
        String(openDriverDetails ?? "").trim() === "100";

    const canViewFadvLoginDetails = Boolean(
        permissionData?.CallViewFadvLoginDetailsAccess
    );

    const [personalAndApplicationAccordionOpenIds, setPersonalAndApplicationAccordionOpenIds] =
        useState(["1"]);
    const [callDetailsTabOrder, setCallDetailsTabOrder] = useState(
        loadCallDetailsTabOrderFromStorage
    );
    const [activeTab, setActiveTab] = useState(
        () => loadCallDetailsTabOrderFromStorage()[0] || "1"
    );
    const messageRef = useRef(null);
    const pendingDrivingExpOpenRef = useRef(false);
    const pendingFedexOpenRef = useRef(false);
    const [messageModalOpenClose, setMessageModalOpenClose] =
        useState(false);
    const [conversationLoading, setConversationLoading] = useState(false);
    const [conversationMessages, setConversationMessages] = useState([]);
    const [conversationTemplates, setConversationTemplates] = useState([]);
    const [aiCallScheduledModalOpen, setAiCallScheduledModalOpen] = useState(false);
    const [aiCallScheduledLoading, setAiCallScheduledLoading] = useState(false);
    const [aiCallScheduledRows, setAiCallScheduledRows] = useState([]);
    const [aiCallRequestModalOpen, setAiCallRequestModalOpen] = useState(false);
    const [aiCallRequestSubmitting, setAiCallRequestSubmitting] = useState(false);
    const [aiRecruiterOptInSubmitting, setAiRecruiterOptInSubmitting] = useState(false);
    const [aiRecruiterOptOutModalOpen, setAiRecruiterOptOutModalOpen] = useState(false);
    const [isDriverDetailsModalOpen, setIsDriverDetailsModalOpen] =
        useState(false);
    const [isPreScreeningModalOpen, setIsPreScreeningModalOpen] = useState(
        () => !shouldAutoOpenDriverDetailsModal
    );
    const [isBadFitResolutionModalOpen, setIsBadFitResolutionModalOpen] = useState(false);
    const [imagePreviewModalOpenClose, setImagePreviewModalOpenClose] =
        useState(false);
    const [candidateId, setCandidateId] =
        useState();

    const [formData, setFormData] = useState({
        status: "No",
    });
    const [loading, setLoading] = useState(false);
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [callDetailsClientInfo, setCallDetailsClientInfo] = useState(null);
    const [callDetailsClientInfoLoading, setCallDetailsClientInfoLoading] =
        useState(false);
    const [drivingExpModalOpen, setDrivingExpModalOpen] = useState(false);
    const [drivingExpCheckboxKey, setDrivingExpCheckboxKey] = useState(0);
    const [drivingExpDefaultChecked, setDrivingExpDefaultChecked] = useState(false);
    const [fedexModalOpen, setFedexModalOpen] = useState(false);
    const [fedexCheckboxKey, setFedexCheckboxKey] = useState(0);
    const [fedexDefaultChecked, setFedexDefaultChecked] = useState(false);
    const [showFadvPassword, setShowFadvPassword] = useState(true);
    const [showFadvSecret, setShowFadvSecret] = useState(true);
    const [callNotesSpecialNotesInput, setCallNotesSpecialNotesInput] = useState("");
    const [callNotesSelectedStatusValue, setCallNotesSelectedStatusValue] = useState("");
    const [callNotesContentInput, setCallNotesContentInput] = useState("");
    const [callNotesScheduledDateTimeValue, setCallNotesScheduledDateTimeValue] = useState("");
    const [callNotesDrugTestAndDotCompletionDateValue, setCallNotesDrugTestAndDotCompletionDateValue] =
        useState("");
    const [callNotesFormSubmitInProgress, setCallNotesFormSubmitInProgress] = useState(false);
    const [callStatusDropdownOptions, setCallStatusDropdownOptions] = useState([]);
    const [notInterestedReasonDropdownOptions, setNotInterestedReasonDropdownOptions] = useState([]);
    const [notInterestedReasonsLoading, setNotInterestedReasonsLoading] = useState(false);
    const [callNotesSelectedNotInterestedReasonId, setCallNotesSelectedNotInterestedReasonId] =
        useState("");
    const [callActivities, setCallActivities] = useState([]);
    const [otherClientActivityGroups, setOtherClientActivityGroups] = useState([]);
    const [callActivitiesLoading, setCallActivitiesLoading] = useState(false);
    const [callNotesAccordionOpen, setCallNotesAccordionOpen] = useState([]);
    const [otherInfoAccordionOpen, setOtherInfoAccordionOpen] = useState([]);
    const [aiTranscriptAccordionOpen, setAiTranscriptAccordionOpen] = useState([]);
    const [aiTranscriptModal, setAiTranscriptModal] = useState({
        open: false,
        loading: false,
        row: null,
    });
    const [candidateApplicationStatusTestRows, setCandidateApplicationStatusTestRows] = useState([]);
    const [candidateApplicationStatusTestsLoading, setCandidateApplicationStatusTestsLoading] =
        useState(false);
    const [candidateTestsApiCandidateClientId, setCandidateTestsApiCandidateClientId] = useState("");
    const [candidateTestsApiCandidateId, setCandidateTestsApiCandidateId] = useState("");
    const [fadvPanelRecord, setFadvPanelRecord] = useState(null);
    const [fadvPanelLoading, setFadvPanelLoading] = useState(false);
    const [fadvPackageOptions, setFadvPackageOptions] = useState([]);
    const [fadvPackagesLoading, setFadvPackagesLoading] = useState(false);
    const [selectedFadvPackageId, setSelectedFadvPackageId] = useState("");
    const [fadvSendSubmitting, setFadvSendSubmitting] = useState(false);
    const [sendFadvLinkYesNoOptions, setSendFadvLinkYesNoOptions] = useState([]);
    const [sendFadvLinkSelectValue, setSendFadvLinkSelectValue] = useState("");
    const [sendFadvLinkOptionsLoading, setSendFadvLinkOptionsLoading] = useState(false);
    const [sendFadvLinkSaving, setSendFadvLinkSaving] = useState(false);
    const [profileDetailsRecord, setProfileDetailsRecord] = useState(null);
    const [driverDetailsRecord, setDriverDetailsRecord] = useState(null);
    const profileDetailsMutationBusyRef = useRef(false);
    const driverDetailsMutationBusyRef = useRef(false);
    const [isExistingFedexDriver, setIsExistingFedexDriver] = useState(false);
    const [isDriverExperience, setIsDriverExperience] = useState(false);
    const [toolbarData, setToolbarData] = useState(false);
    const [toolbarPageActions, setToolbarPageActions] = useState([]);
    const [toolbarInterview, setToolbarInterview] = useState(null);
    const [toolbarCandidateClientId, setToolbarCandidateClientId] = useState("");
    const [toolbarPageActionSubmittingKind, setToolbarPageActionSubmittingKind] =
        useState(null);
    const [jobPortalLink, setJobPortalLink] = useState("");
    const [candidateDashboardLink, setCandidateDashboardLink] = useState("");
    const [dashboardLinkSendCount, setDashboardLinkSendCount] = useState(null);
    const [unreadConversationCount, setUnreadConversationCount] = useState(0);
    const [fadvOrderPlaceFile, setFadvOrderPlaceFile] = useState("");
    const [driverProfileMetadataRows, setDriverProfileMetadataRows] = useState([]);
    const [driverProfileMetadataLoading, setDriverProfileMetadataLoading] = useState(false);
    const [driverProfileMetadataError, setDriverProfileMetadataError] = useState("");

    /**
     * Action update URLs (`call/details/{candidateId}/{routeKey}…`) use the candidateId from the
     * candidate-tests payload. Falls back to the route `id` only until the GET resolves so the
     * children always have a usable value.
     */
    const candidateTestActionBodyCandidateId = useMemo(() => {
        const fromTests = String(candidateTestsApiCandidateId ?? "").trim();
        if (fromTests) return fromTests;
        return String(id ?? "").trim();
    }, [candidateTestsApiCandidateId, id]);

    const candidateTestActionBodyCandidateClientId = useMemo(() => {
        const fromTests = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (fromTests) return fromTests;
        return String(id ?? "").trim();
    }, [candidateTestsApiCandidateClientId, id]);

    /** Path segment for `call/details/{id}/pre-screening` — prefer candidate-tests `candidateClientId`, then profile `id`. */
    const preScreeningCandidateClientId = useMemo(() => {
        const fromTests = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (fromTests) return fromTests;
        const fromDetails = String(candidateDetails?.id ?? "").trim();
        if (fromDetails) return fromDetails;
        return String(id ?? "").trim();
    }, [candidateTestsApiCandidateClientId, candidateDetails?.id, id]);

    const reloadCandidateApplicationStatusTests = useCallback(async () => {
        const routeCandidateId = String(id ?? "").trim();
        if (!routeCandidateId) {
            setCandidateApplicationStatusTestRows([]);
            return;
        }
        setCandidateApplicationStatusTestsLoading(true);
        try {
            const candidateTestsResponse = await getCandidateTestsForCallDetails({
                candidateId: routeCandidateId,
            });
            const parsed = parseCandidateTestsApiResponse(candidateTestsResponse);
            setCandidateApplicationStatusTestRows(parsed.rows);
            setCandidateTestsApiCandidateClientId(parsed.candidateClientId ?? "");
            setCandidateTestsApiCandidateId(parsed.candidateId ?? "");
        } catch {
            setCandidateApplicationStatusTestRows([]);
        } finally {
            setCandidateApplicationStatusTestsLoading(false);
        }
    }, [id]);

    const reloadFadvPanel = useCallback(async () => {
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            setFadvPanelRecord(null);
            return;
        }
        // Reload via `call/fadv/package/status/{id}` — package options stay from initial accordion load.
        setFadvPanelLoading(true);
        try {
            const res = await reloadFadvPackageStatusForCallDetails({ candidateClientId: ccid });
            setFadvPanelRecord(extractFadvPanelRecordFromApiResponse(res));
        } catch {
            setFadvPanelRecord(null);
        } finally {
            setFadvPanelLoading(false);
        }
    }, [candidateTestsApiCandidateClientId]);

    const reloadProfileDetailsRecord = useCallback(async () => {
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            setProfileDetailsRecord(null);
            return;
        }
        try {
            const res = await reloadFadvProfileBackgroundImageForCallDetails({
                candidateClientId: ccid,
            });
            setProfileDetailsRecord(extractFadvPanelRecordFromApiResponse(res));
        } catch {
            setProfileDetailsRecord(null);
        }
    }, [candidateTestsApiCandidateClientId]);

    const reloadDriverDetailsRecord = useCallback(async () => {
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            setDriverDetailsRecord(null);
            return;
        }
        try {
            const res = await getFadvDriverProfileImageForCallDetails({ candidateClientId: ccid });
            setDriverDetailsRecord(extractFadvPanelRecordFromApiResponse(res));
        } catch {
            setDriverDetailsRecord(null);
        }
    }, [candidateTestsApiCandidateClientId]);

    useEffect(() => {
        setSelectedFadvPackageId("");
    }, [candidateTestsApiCandidateClientId]);

    useEffect(() => {
        setDrivingExpDefaultChecked(false);
        setDrivingExpCheckboxKey(0);
        setFedexDefaultChecked(false);
        setFedexCheckboxKey(0);
        setCallNotesSelectedStatusValue("");
        setCallNotesContentInput("");
        setCallNotesScheduledDateTimeValue("");
        setCallNotesDrugTestAndDotCompletionDateValue("");
        setCallNotesSpecialNotesInput("");
        setCallNotesSelectedNotInterestedReasonId("");
        setNotInterestedReasonDropdownOptions([]);
        setCandidateTestsApiCandidateClientId("");
        setCandidateTestsApiCandidateId("");
        setCandidateApplicationStatusTestRows([]);
        setCandidateApplicationStatusTestsLoading(false);
        setFadvPanelRecord(null);
        setFadvPackageOptions([]);
        setSelectedFadvPackageId("");
        setProfileDetailsRecord(null);
        setDriverDetailsRecord(null);
        setSendFadvLinkYesNoOptions([]);
        setSendFadvLinkSelectValue("");
        setIsExistingFedexDriver(false);
        setIsDriverExperience(false);
        setDriverProfileMetadataRows([]);
        setDriverProfileMetadataError("");
        setDriverProfileMetadataLoading(false);
    }, [id]);

    const handleChanges = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };


    const togglePersonalAndApplicationAccordionSection = (accordionSectionTargetId) => {
        setPersonalAndApplicationAccordionOpenIds((previousOpenSectionIds) =>
            previousOpenSectionIds.includes(accordionSectionTargetId)
                ? previousOpenSectionIds.filter(
                    (openSectionId) => openSectionId !== accordionSectionTargetId
                )
                : [...previousOpenSectionIds, accordionSectionTargetId]
        );
    };

    const toggleCallNotesAccordion = (accordionId) => {
        setCallNotesAccordionOpen((prev) =>
            prev.includes(accordionId)
                ? prev.filter((i) => i !== accordionId)
                : [...prev, accordionId]
        );
    };

    const toggleOtherInfoAccordion = (accordionId) => {
        setOtherInfoAccordionOpen((prev) =>
            prev.includes(accordionId)
                ? prev.filter((i) => i !== accordionId)
                : [...prev, accordionId]
        );
    };

    const toggleAiTranscriptAccordion = (accordionId) => {
        setAiTranscriptAccordionOpen((prev) =>
            prev.includes(accordionId)
                ? prev.filter((i) => i !== accordionId)
                : [...prev, accordionId]
        );
    };

    const { callInfoActivities, aiTranscriptActivities } = useMemo(() => {
        const callInfo = [];
        const aiTranscripts = [];
        for (const record of callActivities) {
            if (hasAiCallTranscriptId(record)) {
                aiTranscripts.push(record);
            } else {
                callInfo.push(record);
            }
        }
        return { callInfoActivities: callInfo, aiTranscriptActivities: aiTranscripts };
    }, [callActivities]);

    const aiTranscriptModalBody = useMemo(
        () => (aiTranscriptModal.row ? getTranscriptTextFromRow(aiTranscriptModal.row) : ""),
        [aiTranscriptModal.row]
    );

    const aiTranscriptModalMessages = useMemo(
        () =>
            aiTranscriptModal.row ? parseTranscriptMessagesFromRow(aiTranscriptModal.row) : [],
        [aiTranscriptModal.row]
    );

    const handleOpenAiTranscriptModal = useCallback(async (callActivityRecord) => {
        const transcriptId = String(callActivityRecord?.aiCallTranscriptId ?? "").trim();
        if (!transcriptId) return;

        setAiTranscriptModal({ open: true, loading: true, row: null });
        try {
            const response = await getCallDetailsAiTranscript({ aiCallTranscriptId: transcriptId });
            const row = normalizeCallDetailsTranscriptApiResponse(response);
            setAiTranscriptModal({ open: true, loading: false, row });
        } catch {
            setAiTranscriptModal({ open: true, loading: false, row: null });
        }
    }, []);

    const closeAiTranscriptModal = useCallback(() => {
        setAiTranscriptModal({ open: false, loading: false, row: null });
    }, []);

    /* ===== Personal Information editable fields ===== */
    const [personalInfo, setPersonalInfo] = useState({
        email: "",
        fedexId: "",
    });
    const [personalInfoSavingField, setPersonalInfoSavingField] = useState(null);
    const [personalInfoCopiedTooltipMessage, setPersonalInfoCopiedTooltipMessage] = useState("");
    const personalInfoCopiedTooltipTimeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (personalInfoCopiedTooltipTimeoutRef.current) {
                clearTimeout(personalInfoCopiedTooltipTimeoutRef.current);
            }
        };
    }, []);

    const handleCopyPersonalInfoBundle = useCallback(async () => {
        const candidateName = `${candidateDetails?.firstName ?? ""} ${candidateDetails?.lastName ?? ""}`.trim();
        const clientName = pickFirstNonEmptyString(candidateDetails?.clientName);
        const phone = pickFirstNonEmptyString(
            candidateDetails?.phone,
            candidateDetails?.phoneNumber
        );
        const email = pickFirstNonEmptyString(personalInfo.email, candidateDetails?.email);
        const clipboardText = [
            candidateName || "N/A",
            clientName || "N/A",
            email || "N/A",
            phone || "N/A",
        ].join(",\n");
        const tooltipMessage = [
            `Copied candidate full name: ${candidateName || "N/A"}`,
            `client: ${clientName || "N/A"}`,
            `email: ${email || "N/A"}`,
            `phone: ${phone || "N/A"}`,
        ].join(", ");

        try {
            await navigator.clipboard.writeText(clipboardText);
            if (personalInfoCopiedTooltipTimeoutRef.current) {
                clearTimeout(personalInfoCopiedTooltipTimeoutRef.current);
            }
            setPersonalInfoCopiedTooltipMessage(tooltipMessage);
            personalInfoCopiedTooltipTimeoutRef.current = setTimeout(() => {
                setPersonalInfoCopiedTooltipMessage("");
                personalInfoCopiedTooltipTimeoutRef.current = null;
            }, 2500);
        } catch {
            // Keep feedback local; no toaster for this action.
        }
    }, [candidateDetails, personalInfo.email]);

    useEffect(() => {
        if (!candidateDetails) return;
        const rawEmail = candidateDetails?.email;
        const emailOk =
            rawEmail != null &&
            String(rawEmail).trim() !== "" &&
            String(rawEmail).toLowerCase() !== "null";
        setPersonalInfo((prev) => ({
            ...prev,
            email: emailOk ? String(rawEmail).trim() : "",
        }));
    }, [candidateDetails]);

    useEffect(() => {
        if (!candidateDetails) return;
        const rawSpecialNotes =
            candidateDetails?.specialNotes ?? candidateDetails?.special_notes;
        const specialNotesOk =
            rawSpecialNotes != null &&
            String(rawSpecialNotes).trim() !== "" &&
            String(rawSpecialNotes).toLowerCase() !== "null";
        if (specialNotesOk) {
            setCallNotesSpecialNotesInput(String(rawSpecialNotes).trim());
        }
    }, [candidateDetails]);

    /** FedEx ID from GET `call/details/fedex-candidate/:id` (authoritative for display). */
    useEffect(() => {
        if (!id || !candidateDetails) return;
        let cancelled = false;
        (async () => {
            try {
                const response = await getFedexCandidateForCallDetails({ candidateId: id });
                if (cancelled) return;
                const raw = response?.data ?? response;
                if (!raw || typeof raw !== "object") return;
                const fid = String(raw.fedexId ?? raw.fedExId ?? "").trim();
                const ok = fid && fid.toLowerCase() !== "null" && fid.toUpperCase() !== "N/A";
                const display = ok ? fid : "";
                setPersonalInfo((prev) => ({ ...prev, fedexId: display }));
                setCandidateDetails((prev) =>
                    prev ? { ...prev, fedexId: ok ? fid : null, fedex_id: ok ? fid : null } : prev
                );
            } catch {
                /* keep existing fedex display if request fails */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [id, candidateDetails?.id]);

    /** Quota checkboxes + call-status payload flags: reflect `isFedexDriver` / `drivingExperience` from API. */
    useEffect(() => {
        const routeId = String(id ?? "").trim();
        if (!routeId || !candidateDetails) return;
        const rowId = String(candidateDetails?.id ?? "").trim();
        if (rowId && rowId !== routeId) return;
        const fedexChecked = resolveIsFedexDriverDefaultChecked(candidateDetails);
        const drivingChecked = resolveDrivingExperienceDefaultChecked(candidateDetails);
        setFedexDefaultChecked(fedexChecked);
        setFedexCheckboxKey((previousFedexCheckboxKey) => previousFedexCheckboxKey + 1);
        setDrivingExpDefaultChecked(drivingChecked);
        setDrivingExpCheckboxKey((previousDrivingExperienceCheckboxKey) => previousDrivingExperienceCheckboxKey + 1);
        setIsExistingFedexDriver(fedexChecked);
        setIsDriverExperience(drivingChecked);
    }, [
        id,
        candidateDetails?.id,
        candidateDetails?.isFedexDriver,
        candidateDetails?.is_fedex_driver,
        candidateDetails?.fedexDriver,
        candidateDetails?.fedex_driver,
        candidateDetails?.drivingExperience,
        candidateDetails?.driving_experience,
        candidateDetails?.hasDrivingExperience,
        candidateDetails?.has_driving_experience,
        candidateDetails?.isDriverExperience,
        candidateDetails?.is_driver_experience,
        candidateDetails?.driverExperience,
    ]);

    /** Personal Information: Send FADV link? — options from `common/yes-no`, current value from FADV panel. */
    useEffect(() => {
        const ccid = String(candidateDetails?.id ?? "").trim();
        if (!ccid) {
            setSendFadvLinkYesNoOptions([]);
            setSendFadvLinkSelectValue("");
            return;
        }
        let cancelled = false;
        (async () => {
            setSendFadvLinkOptionsLoading(true);
            try {
                const [yesNoRes, panelRes] = await Promise.all([
                    fetchCommonYesNoOptions(),
                    getFadvPanelForCallDetails({ candidateClientId: ccid }),
                ]);
                if (cancelled) return;
                const optionRecords = yesNoRes?.data ?? yesNoRes;
                const normalizedRecords = Array.isArray(optionRecords)
                    ? optionRecords
                    : Array.isArray(optionRecords?.data)
                        ? optionRecords.data
                        : [];
                const opts = mapCommonDropdownRecords(normalizedRecords);
                setSendFadvLinkYesNoOptions(opts);
                const panel = extractFadvPanelRecordFromApiResponse(panelRes);
                setFadvPanelRecord(panel);
                const raw = panel?.sendFadvLink ?? panel?.sendFadv_link ?? "";
                setSendFadvLinkSelectValue(resolveSendFadvLinkSelectValueFromPanel(raw, opts));
            } catch {
                if (!cancelled) {
                    setSendFadvLinkYesNoOptions([]);
                    setSendFadvLinkSelectValue("");
                    setFadvPanelRecord(null);
                }
            } finally {
                if (!cancelled) setSendFadvLinkOptionsLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [candidateDetails?.id]);

    const normalizedEmailFromDetails = (details) => {
        const raw = details?.email;
        if (raw == null || String(raw).trim() === "" || String(raw).toLowerCase() === "null") {
            return "";
        }
        return String(raw).trim();
    };

    const validateCallDetailsPersonalEmail = (emailValue) => {
        const trimmed = String(emailValue ?? "").trim();
        if (!trimmed) {
            return { valid: false, message: "Please enter an email address." };
        }
        const atIndex = trimmed.indexOf("@");
        if (atIndex <= 0 || atIndex !== trimmed.lastIndexOf("@")) {
            return { valid: false, message: "Enter a valid email address." };
        }
        const domain = trimmed.slice(atIndex + 1);
        const domainLabels = domain.split(".");
        const tld = domainLabels[domainLabels.length - 1] ?? "";
        const hasValidDomain =
            domain.includes(".") &&
            domainLabels.length >= 2 &&
            domainLabels.every((label) => label.length > 0) &&
            /^[a-zA-Z]{2,}$/.test(tld);
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!hasValidDomain || !emailPattern.test(trimmed)) {
            return { valid: false, message: "Enter a valid email address." };
        }
        return { valid: true, message: "" };
    };

    /** @returns {Promise<boolean>} false reverts draft to last saved value */
    const handleEmailSave = async (nextValue) => {
        const trimmed = String(nextValue ?? "").trim();
        const original = normalizedEmailFromDetails(candidateDetails);

        if (!id) return true;
        if (trimmed === original) return true;

        setPersonalInfoSavingField("email");
        try {
            const response = await updateCallDetailsEmail({ callDetailsId: id, value: trimmed });
            const ok =
                response?.success ||
                response?.isSuccess ||
                response?.status === "success" ||
                response?.status === true;
            if (ok) {
                toast.success(response?.message || "Email updated");
                setPersonalInfo((prev) => ({ ...prev, email: trimmed }));
                setCandidateDetails((prev) => (prev ? { ...prev, email: trimmed } : prev));
                return true;
            }
            toast.error(response?.message || "Email update failed");
            return false;
        } finally {
            setPersonalInfoSavingField(null);
        }
    };

    const normalizedFedexIdFromDetails = (details) => {
        const raw = details?.fedexId ?? details?.fedex_id;
        if (raw == null || String(raw).trim() === "" || String(raw).toLowerCase() === "null") {
            return "";
        }
        const trimmed = String(raw).trim();
        if (trimmed.toUpperCase() === "N/A") return "";
        return trimmed;
    };

    /** @returns {Promise<boolean>} false keeps inline editor open */
    const handleFedexIdSave = async (nextValue) => {
        const trimmed = String(nextValue ?? "").trim();
        const original = normalizedFedexIdFromDetails(candidateDetails);

        if (!id) return true;
        if (trimmed === original) return true;

        setPersonalInfoSavingField("fedexId");
        try {
            const response = await updateCallDetailsFedexId({ callDetailsId: id, value: trimmed });
            const ok =
                response?.success ||
                response?.isSuccess ||
                response?.status === "success" ||
                response?.status === true;
            if (ok) {
                toast.success(response?.message || "FedEx ID updated");
                setPersonalInfo((prev) => ({ ...prev, fedexId: trimmed }));
                setCandidateDetails((prev) =>
                    prev ? { ...prev, fedexId: trimmed || null, fedex_id: trimmed || null } : prev
                );
                return true;
            }
            toast.error(response?.message);
            return false;
        } finally {
            setPersonalInfoSavingField(null);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleSendFadvLinkSelectChange = useCallback(
        async (event) => {
            const next = String(event.target.value ?? "").trim();
            const ccid = String(candidateDetails?.id ?? "").trim();
            if (!ccid) {
                toast.error("Candidate client id is missing.");
                return;
            }
            const previous = sendFadvLinkSelectValue;
            if (next === previous) return;
            setSendFadvLinkSelectValue(next);
            setSendFadvLinkSaving(true);
            try {
                const res = await sendFadvSendLinkForCallDetails({
                    candidateClientId: ccid,
                    value: next,
                });
                const ok =
                    res?.success ||
                    res?.isSuccess ||
                    res?.status === "success" ||
                    res?.status === true;
                if (ok) {
                    toast.success(res?.message || "Send FADV link setting updated.");
                    setFadvPanelRecord((prev) =>
                        prev && typeof prev === "object" ? { ...prev, sendFadvLink: next } : prev
                    );
                } else {
                    // toast.error(res?.message || "Update failed.");
                    setSendFadvLinkSelectValue(previous);
                }
            } catch {
                setSendFadvLinkSelectValue(previous);
            } finally {
                setSendFadvLinkSaving(false);
            }
        },
        [candidateDetails?.id, sendFadvLinkSelectValue]
    );

    const handleFadvPackageSendClick = useCallback(async () => {
        if (fadvSendSubmitting) return;
        const candidateClientId = String(
            fadvPanelRecord?.candidateClientId ?? candidateTestsApiCandidateClientId ?? ""
        ).trim();
        const fadvApiId = String(selectedFadvPackageId ?? "").trim();
        const email = String(personalInfo.email ?? "").trim();
        if (!candidateClientId) {
            toast.error("Candidate client id is not available yet.");
            return;
        }
        if (!fadvApiId) {
            toast.error("Select a FADV package.");
            return;
        }
        if (!email) {
            toast.error("Candidate email is required.");
            return;
        }
        const emailValidation = validateCallDetailsPersonalEmail(email);
        if (!emailValidation.valid) {
            toast.error(emailValidation.message);
            return;
        }
        const confirmed = await confirmCallDetailsApplicationStatusSend(
            "Are you sure you want to send this FADV package?"
        );
        if (!confirmed) return;
        setFadvSendSubmitting(true);
        try {
            const res = await sendFadvPackageForCallDetails({ candidateClientId, fadvApiId, email });
            const ok =
                res?.success ||
                res?.isSuccess ||
                res?.status === "success" ||
                res?.status === true;
            if (ok) {
                toast.success(res?.message || "FADV package sent.");
                await reloadFadvPanel();
            } else {
                // toast.error(res?.message || res?.error?.message || "Unable to send FADV package.");
            }
        } finally {
            setFadvSendSubmitting(false);
        }
    }, [
        candidateTestsApiCandidateClientId,
        fadvPanelRecord,
        fadvSendSubmitting,
        personalInfo.email,
        reloadFadvPanel,
        selectedFadvPackageId,
    ]);

    const handleProfileDetailsBackgroundReload = useCallback(async () => {
        if (profileDetailsMutationBusyRef.current) return;
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            toast.error("Candidate client id is not available yet.");
            return;
        }
        profileDetailsMutationBusyRef.current = true;
        try {
            // Only `call/fadv/profile-details/background-image/{id}` — do not refresh FADV panel / packages.
            const res = await reloadFadvProfileBackgroundImageForCallDetails({
                candidateClientId: ccid,
            });
            const record = extractFadvPanelRecordFromApiResponse(res);
            const ok =
                res?.success ||
                res?.isSuccess ||
                res?.status === "success" ||
                res?.status === true ||
                record;
            if (ok) toast.success(res?.message || "Profile background image reloaded.");
            setProfileDetailsRecord(record);
        } finally {
            profileDetailsMutationBusyRef.current = false;
        }
    }, [candidateTestsApiCandidateClientId]);

    const handleProfileDetailsOrderSend = useCallback(async () => {
        if (profileDetailsMutationBusyRef.current) return;
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            toast.error("Candidate client id is not available yet.");
            return;
        }
        const confirmed = await confirmCallDetailsApplicationStatusSend(
            "Are you sure you want to send profile order details?"
        );
        if (!confirmed) return;
        profileDetailsMutationBusyRef.current = true;
        try {
            const res = await sendFadvProfileOrderDetailsForCallDetails({
                candidateClientId: ccid,
            });
            const ok =
                res?.success ||
                res?.isSuccess ||
                res?.status === "success" ||
                res?.status === true;
            if (ok) toast.success(res?.message || "Order details sent.");
            await reloadProfileDetailsRecord();
        } finally {
            profileDetailsMutationBusyRef.current = false;
        }
    }, [candidateTestsApiCandidateClientId, reloadProfileDetailsRecord]);

    const handleDriverDetailsImageReload = useCallback(async () => {
        if (driverDetailsMutationBusyRef.current) return;
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            toast.error("Candidate client id is not available yet.");
            return;
        }
        driverDetailsMutationBusyRef.current = true;
        try {
            const res = await getFadvDriverProfileImageForCallDetails({ candidateClientId: ccid });
            const record = extractFadvPanelRecordFromApiResponse(res);
            const ok =
                res?.success ||
                res?.isSuccess ||
                res?.status === "success" ||
                res?.status === true ||
                record;
            if (ok) toast.success(res?.message || "Driver profile image reloaded.");
            setDriverDetailsRecord(record);
        } finally {
            driverDetailsMutationBusyRef.current = false;
        }
    }, [candidateTestsApiCandidateClientId]);

    const handleDriverDetailsApiSend = useCallback(async () => {
        if (driverDetailsMutationBusyRef.current) return;
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            toast.error("Candidate client id is not available yet.");
            return;
        }
        const confirmed = await confirmCallDetailsApplicationStatusSend(
            "Are you sure you want to send driver details?"
        );
        if (!confirmed) return;
        driverDetailsMutationBusyRef.current = true;
        try {
            const res = await sendFadvDriverProfileApiForCallDetails({
                candidateClientId: ccid,
            });
            const ok =
                res?.success ||
                res?.isSuccess ||
                res?.status === "success" ||
                res?.status === true;
            if (ok) toast.success(res?.message || "Driver details sent.");
            await reloadDriverDetailsRecord();
        } finally {
            driverDetailsMutationBusyRef.current = false;
        }
    }, [candidateTestsApiCandidateClientId, reloadDriverDetailsRecord]);

    const getCallDetailsUpperToolbarDetails = useCallback(async (candidateClientId) => {
        const response = await getCallDetailsUpperToolbar({
            candidateClientId,
        });
        const data = response?.data;
        if (response) {
            const portalLinks =
                data?.portalLinks && typeof data.portalLinks === "object"
                    ? data.portalLinks
                    : null;
            setJobPortalLink(
                portalLinks?.jobPortalLink ?? data?.jobPortalLink ?? ""
            );
            setCandidateDashboardLink(
                portalLinks?.candidateDashboardLink ??
                    data?.candidateDashboardLink ??
                    ""
            );
            const sendCount = portalLinks?.dashboardLinkSendCount;
            setDashboardLinkSendCount(
                sendCount === null || sendCount === undefined || sendCount === ""
                    ? null
                    : Number(sendCount)
            );
            const unreadCount = data?.unreadConversationCount;
            setUnreadConversationCount(
                unreadCount === null || unreadCount === undefined || unreadCount === ""
                    ? 0
                    : Math.max(0, Number(unreadCount) || 0)
            );
            setToolbarData(data?.toolbar ?? null);
            setToolbarPageActions(
                Array.isArray(data?.pageActions) ? data.pageActions : []
            );
            setToolbarInterview(
                data?.toolbar?.toolbarInterview ?? data?.toolbarInterview ?? null
            );
            setToolbarCandidateClientId(
                String(data?.candidateClientId ?? candidateClientId ?? "").trim()
            );
            const orderPlaceFileRaw =
                data?.fadvOrderPlaceFile ??
                data?.toolbar?.fadvOrderPlaceFile ??
                "";
            const orderPlaceFileUrl =
                typeof orderPlaceFileRaw === "string"
                    ? orderPlaceFileRaw.trim()
                    : String(
                          orderPlaceFileRaw?.url ??
                              orderPlaceFileRaw?.fileUrl ??
                              orderPlaceFileRaw?.link ??
                              orderPlaceFileRaw?.downloadUrl ??
                              ""
                      ).trim();
            setFadvOrderPlaceFile(orderPlaceFileUrl);
        } else {
            setToolbarData(null);
            setToolbarPageActions([]);
            setToolbarInterview(null);
            setToolbarCandidateClientId("");
            setDashboardLinkSendCount(null);
            setUnreadConversationCount(0);
            setFadvOrderPlaceFile("");
        }
    }, []);

    const candidateDashboardSendAction = useMemo(
        () =>
            toolbarPageActions.find(
                (action) => action?.kind === "candidate-dashboard-link-send"
            ) ?? null,
        [toolbarPageActions]
    );

    const sendInterviewLinkAction = useMemo(
        () =>
            toolbarPageActions.find(
                (action) => action?.kind === "send-interview-link"
            ) ?? null,
        [toolbarPageActions]
    );

    const interviewLinkDisplayValue = useMemo(() => {
        const interviewUrl = String(toolbarInterview?.interviewVideoUrl ?? "").trim();
        if (interviewUrl) return interviewUrl;
        const interviewDisplay = String(
            toolbarInterview?.interviewVideoDisplay ?? ""
        ).trim();
        return interviewDisplay || "N/A";
    }, [toolbarInterview?.interviewVideoDisplay, toolbarInterview?.interviewVideoUrl]);

    const handleToolbarPageActionClick = useCallback(
        async (action) => {
            const actionKind = String(action?.kind ?? "").trim();
            const routeKey = String(action?.routeKey ?? "").trim();
            if (!actionKind || !routeKey || toolbarPageActionSubmittingKind) {
                return;
            }

            const confirmed = await confirmCallDetailsApplicationStatusSend(
                action?.confirmMessage || "Are you sure?"
            );
            if (!confirmed) return;

            setToolbarPageActionSubmittingKind(actionKind);
            try {
                const response = await invokeCallDetailsPageActionPost({
                    routeKey,
                    requestBody: toolbarCandidateClientId
                        ? { candidateClientId: toolbarCandidateClientId }
                        : {},
                });
                const ok =
                    response?.success ||
                    response?.isSuccess ||
                    response?.status === "success" ||
                    response?.status === true;
                if (ok) {
                    toast.success(response?.message || "Sent successfully");
                    const routeCandidateClientId = String(id ?? "").trim();
                    if (routeCandidateClientId) {
                        await getCallDetailsUpperToolbarDetails(
                            routeCandidateClientId
                        );
                    }
                    await reloadCandidateApplicationStatusTests();
                } else {
                    toast.error(response?.message || "Something went wrong");
                }
            } finally {
                setToolbarPageActionSubmittingKind(null);
            }
        },
        [
            getCallDetailsUpperToolbarDetails,
            id,
            reloadCandidateApplicationStatusTests,
            toolbarCandidateClientId,
            toolbarPageActionSubmittingKind,
        ]
    );

    const handleCopyJobPortalLink = useCallback(async () => {
        const link = String(jobPortalLink ?? "").trim();
        if (!link) {
            return;
        }
        try {
            await navigator.clipboard.writeText(link);
            toast.success(`copied ${link}`, {
                className: "toast-text-wrap",
                style: {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    maxWidth: "min(28rem, 92vw)",
                },
                bodyStyle: {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                },
            });
        } catch {
            toast.error("Unable to copy job portal link");
        }
    }, [jobPortalLink]);

    const handleCopyCandidateDashboardLink = useCallback(async () => {
        const link = String(candidateDashboardLink ?? "").trim();
        if (!link) {
            return;
        }
        try {
            await navigator.clipboard.writeText(link);
            toast.success(`copied ${link}`, {
                className: "toast-text-wrap",
                style: {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    maxWidth: "min(28rem, 92vw)",
                },
                bodyStyle: {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                },
            });
        } catch {
            toast.error("Unable to copy candidate dashboard link");
        }
    }, [candidateDashboardLink]);

    useEffect(() => {
        setCandidateId(id);
        setCallNotesAccordionOpen([]);
        setOtherInfoAccordionOpen([]);
        setAiTranscriptAccordionOpen([]);
        setCallActivities([]);
        setOtherClientActivityGroups([]);
        if (!shouldAutoOpenDriverDetailsModal) {
            setIsDriverDetailsModalOpen(false);
        } else {
            setIsPreScreeningModalOpen(false);
        }
        if (id) {
            fetchCandidateDetails(id)
            getCallDetailsUpperToolbarDetails(id)
        }
    }, [id, shouldAutoOpenDriverDetailsModal])

    useEffect(() => {
        if (!shouldAutoOpenDriverDetailsModal || !String(id ?? "").trim()) return;
        setIsPreScreeningModalOpen(false);
        setIsDriverDetailsModalOpen(true);
    }, [shouldAutoOpenDriverDetailsModal, id]);

    useEffect(() => {
        const shouldLoadCallActivities = activeTab === "2" || activeTab === "3";
        if (!shouldLoadCallActivities || !id) return;
        let cancelled = false;
        (async () => {
            setCallActivitiesLoading(true);
            try {
                const response = await getCallInfo({ candidateId: id });
                if (cancelled) return;
                setCallActivities(parseCallActivitiesList(response));
                setOtherClientActivityGroups(parseOtherClientActivitiesGroups(response));
            } catch {
                if (!cancelled) {
                    setCallActivities([]);
                    setOtherClientActivityGroups([]);
                }
            } finally {
                if (!cancelled) setCallActivitiesLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [activeTab, id]);

    const isApplicationStatusAccordionOpen = useMemo(
        () => personalAndApplicationAccordionOpenIds.includes("2"),
        [personalAndApplicationAccordionOpenIds]
    );

    const driverProfileMetadataCandidateClientId = useMemo(
        () =>
            String(
                candidateTestsApiCandidateClientId ||
                    candidateDetails?.id ||
                    id ||
                    ""
            ).trim(),
        [candidateTestsApiCandidateClientId, candidateDetails?.id, id]
    );

    const loadDriverProfileMetadata = useCallback(async () => {
        const ccid = String(driverProfileMetadataCandidateClientId ?? "").trim();
        if (!ccid) {
            setDriverProfileMetadataRows([]);
            setDriverProfileMetadataError("");
            return;
        }
        setDriverProfileMetadataLoading(true);
        setDriverProfileMetadataError("");
        try {
            const response = await getFadvDriverProfileMetadataForCallDetails({
                candidateClientId: ccid,
            });
            if (response?.success === false) {
                setDriverProfileMetadataRows([]);
                setDriverProfileMetadataError(
                    response?.message || "Unable to load driver profile metadata."
                );
                return;
            }
            setDriverProfileMetadataRows(
                extractFadvDriverProfileMetadataRowsFromApiResponse(response)
            );
        } catch (error) {
            setDriverProfileMetadataRows([]);
            setDriverProfileMetadataError(
                error?.message || "Unable to load driver profile metadata."
            );
        } finally {
            setDriverProfileMetadataLoading(false);
        }
    }, [driverProfileMetadataCandidateClientId]);

    useEffect(() => {
        loadDriverProfileMetadata();
    }, [loadDriverProfileMetadata]);

    const profileImagePresentation = useMemo(() => {
        const href = resolveDriverProfileImageHref(profileDetailsRecord);
        const label =
            href && href.length > 52 ? `${href.slice(0, 44)}…` : href || "N/A";
        return { href, label };
    }, [profileDetailsRecord]);

    const driverImagePresentation = useMemo(() => {
        const href = resolveDriverProfileImageHref(driverDetailsRecord);
        const label =
            href && href.length > 52 ? `${href.slice(0, 44)}…` : href || "N/A";
        return { href, label };
    }, [driverDetailsRecord]);

    const profileLastUpdatedDisplay = useMemo(() => {
        const fromRecord = resolveDriverProfileLastUpdatedLabel(profileDetailsRecord);
        if (fromRecord !== "N/A") return fromRecord;
        const fromCandidate = candidateDetails?.fadvLastUpdatedTime;
        if (!fromCandidate) return "N/A";
        return dayjs(fromCandidate).isValid()
            ? dayjs(fromCandidate).format("h:mm A MM-DD-YYYY")
            : String(fromCandidate);
    }, [profileDetailsRecord, candidateDetails?.fadvLastUpdatedTime]);

    const driverLastUpdatedDisplay = useMemo(
        () => resolveDriverProfileLastUpdatedLabel(driverDetailsRecord),
        [driverDetailsRecord]
    );

    const shouldShowDriverDetailsSection = useMemo(
        () => isOrderStatusEligibleForDriverDetailsSection(candidateDetails?.orderStatus),
        [candidateDetails?.orderStatus]
    );

    const candidateResumeDownloadUrl = useMemo(() => {
        const url = String(
            candidateDetails?.resumeUploadLink ??
            candidateDetails?.resumeLink ??
            candidateDetails?.resumeUrl ??
            candidateDetails?.CV ??
            candidateDetails?.downloadURL ??
            ""
        ).trim();
        return url;
    }, [candidateDetails]);

    const candidateResumeFileName = useMemo(() => {
        if (!candidateResumeDownloadUrl) return "";
        const fromPath = candidateResumeDownloadUrl.split("/").pop()?.split("?")[0];
        return fromPath ? decodeURIComponent(fromPath) : "Resume";
    }, [candidateResumeDownloadUrl]);

    const handleDownloadResumeClick = () => {
        if (!candidateResumeDownloadUrl) {
            toast.error("Resume download link is not available.");
            return;
        }
        downloadFileFromUrl(candidateResumeDownloadUrl);
    };

    useEffect(() => {
        if (!isApplicationStatusAccordionOpen) return;
        const routeCandidateId = String(id ?? "").trim();
        if (!routeCandidateId) return;
        let cancelled = false;
        (async () => {
            setCandidateApplicationStatusTestsLoading(true);
            try {
                const candidateTestsResponse = await getCandidateTestsForCallDetails({
                    candidateId: routeCandidateId,
                });
                if (cancelled) return;
                const parsed = parseCandidateTestsApiResponse(candidateTestsResponse);
                setCandidateApplicationStatusTestRows(parsed.rows);
                setCandidateTestsApiCandidateClientId(parsed.candidateClientId ?? "");
                setCandidateTestsApiCandidateId(parsed.candidateId ?? "");
            } catch {
                if (!cancelled) setCandidateApplicationStatusTestRows([]);
            } finally {
                if (!cancelled) setCandidateApplicationStatusTestsLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [isApplicationStatusAccordionOpen, id]);

    useEffect(() => {
        if (!isApplicationStatusAccordionOpen) {
            setFadvPackageOptions([]);
            setProfileDetailsRecord(null);
            setDriverDetailsRecord(null);
            return;
        }
    }, [isApplicationStatusAccordionOpen]);

    useEffect(() => {
        if (!isApplicationStatusAccordionOpen) return;
        const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
        if (!ccid) {
            setFadvPanelRecord(null);
            setFadvPanelLoading(false);
            setFadvPackageOptions([]);
            return;
        }
        let cancelled = false;
        (async () => {
            setFadvPanelLoading(true);
            setFadvPackagesLoading(true);
            try {
                const res = await getFadvPanelForCallDetails({ candidateClientId: ccid });
                if (cancelled) return;
                const panel = extractFadvPanelRecordFromApiResponse(res);
                setFadvPanelRecord(panel);

                const primaryIds = (Array.isArray(panel?.fadvApiIds) ? panel.fadvApiIds : [])
                    .map((fadvApiId) => String(fadvApiId ?? "").trim())
                    .filter(Boolean);

                const packageRes = await getFadvPackageOptionsForCallDetails({ primaryIds });
                if (cancelled) return;
                setFadvPackageOptions(extractFadvPackageOptionsFromApiResponse(packageRes));
            } catch {
                if (!cancelled) {
                    setFadvPanelRecord(null);
                    setFadvPackageOptions([]);
                }
            } finally {
                if (!cancelled) {
                    setFadvPanelLoading(false);
                    setFadvPackagesLoading(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [isApplicationStatusAccordionOpen, candidateTestsApiCandidateClientId]);

    useEffect(() => {
        if (!isApplicationStatusAccordionOpen) return;
        let cancelled = false;
        (async () => {
            const ccid = String(candidateTestsApiCandidateClientId ?? "").trim();
            if (!ccid) {
                setProfileDetailsRecord(null);
                setDriverDetailsRecord(null);
                return;
            }
            const loadDriverDetails = isOrderStatusEligibleForDriverDetailsSection(
                candidateDetails?.orderStatus
            );
            if (!loadDriverDetails) {
                setDriverDetailsRecord(null);
            }
            try {
                const profileRes = await reloadFadvProfileBackgroundImageForCallDetails({
                    candidateClientId: ccid,
                });
                if (cancelled) return;
                setProfileDetailsRecord(extractFadvPanelRecordFromApiResponse(profileRes));
                if (loadDriverDetails) {
                    const driverRes = await getFadvDriverProfileImageForCallDetails({
                        candidateClientId: ccid,
                    });
                    if (cancelled) return;
                    setDriverDetailsRecord(extractFadvPanelRecordFromApiResponse(driverRes));
                }
            } catch {
                if (!cancelled) {
                    setProfileDetailsRecord(null);
                    setDriverDetailsRecord(null);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [
        isApplicationStatusAccordionOpen,
        candidateTestsApiCandidateClientId,
        candidateDetails?.orderStatus,
    ]);

    useEffect(() => {
        const callDetailsId = String(id ?? "").trim();
        if (!callDetailsId) {
            setCallDetailsClientInfo(null);
            return;
        }
        let cancelled = false;
        (async () => {
            setCallDetailsClientInfoLoading(true);
            try {
                const response = await getCallDetailsClientInfo({
                    callDetailsId,
                });
                if (cancelled) return;
                setCallDetailsClientInfo(
                    parseCallDetailsClientInfoApiResponse(response)
                );
            } catch {
                if (!cancelled) setCallDetailsClientInfo(null);
            } finally {
                if (!cancelled) setCallDetailsClientInfoLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [id]);

    useEffect(() => {
        setShowFadvPassword(true);
        setShowFadvSecret(true);
    }, [callDetailsClientInfo?.clientId]);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const loggedInUserTypeId = resolveLoggedInUserTypeId();
                const profileComplete =
                    candidateDetails &&
                    isCallStatusCompleted(candidateDetails?.profileStatus);

                let res;
                if(toolbarData){
                if (toolbarData?.guestReadOnly) {
                    res = await fetchCommonCallStatusMergeOptions({
                        isComplete: true,
                        showEligible: true,
                        guestAccess: true,
                    });
                } else if (profileComplete) {
                    res = await fetchCommonCallStatusMergeOptions({
                        isComplete: true,
                        showEligible: loggedInUserTypeId !== 5,
                        guestAccess: toolbarData?.guestReadOnly ? true : false,
                    });
                } else {
                    res = await fetchCommonCallStatusOptions();
                }
            }
                if (cancelled) return;
                const raw = res?.data ?? res;
                const list = Array.isArray(raw) ? raw : [];
                setCallStatusDropdownOptions(mapCommonDropdownRecords(list));
            } catch {
                if (!cancelled) setCallStatusDropdownOptions([]);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [candidateDetails?.profileStatus, toolbarData]);

    useEffect(() => {
        if (!shouldShowCallNotesNotInterestedReasonDropdown(callNotesSelectedStatusValue)) {
            setNotInterestedReasonDropdownOptions([]);
            setNotInterestedReasonsLoading(false);
            setCallNotesSelectedNotInterestedReasonId("");
            return;
        }
        let requestCancelled = false;
        (async () => {
            setNotInterestedReasonsLoading(true);
            try {
                const filterResponse = await commonReasonData({});
                if (requestCancelled) return;
                const reasonRows = Array.isArray(filterResponse?.data)
                    ? filterResponse.data
                    : [];
                setNotInterestedReasonDropdownOptions(
                    mapReasonMasterFilterRowsToSelectOptions(reasonRows)
                );
            } catch {
                if (!requestCancelled) setNotInterestedReasonDropdownOptions([]);
            } finally {
                if (!requestCancelled) setNotInterestedReasonsLoading(false);
            }
        })();
        return () => {
            requestCancelled = true;
        };
    }, [callNotesSelectedStatusValue]);

    const applyCallNotesCallStatusSelection = useCallback((nextStatus) => {
        setCallNotesSelectedStatusValue(nextStatus);
        setCallNotesSelectedNotInterestedReasonId("");
        if (!shouldShowCallNotesScheduleDateAndTimeFields(nextStatus)) {
            setCallNotesScheduledDateTimeValue("");
        }
        if (!shouldShowCallNotesDrugTestAndDotCompletionDateFields(nextStatus)) {
            setCallNotesDrugTestAndDotCompletionDateValue("");
        }
    }, []);

    const handleCallNotesCallStatusChange = useCallback(
        async (event) => {
            const nextStatus = event.target.value;

            if (isCallStatusEligible(nextStatus)) {
                const confirmation = await Swal.fire({
                    title: "Eligible",
                    text: "Are you sure you want to select Eligible?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                });

                if (!confirmation?.isConfirmed) {
                    applyCallNotesCallStatusSelection("");
                    return;
                }
            }

            applyCallNotesCallStatusSelection(nextStatus);
        },
        [applyCallNotesCallStatusSelection]
    );

    const handleCallNotesFormSubmit = async (event) => {
        event.preventDefault();
        const candidateClientId =
            candidateDetails?.id != null ? String(candidateDetails.id).trim() : "";
        if (!candidateClientId) {
            toast.error("Candidate is not loaded.");
            return;
        }
        const selectedCallStatusType = String(callNotesSelectedStatusValue ?? "").trim();
        const callNotesText = String(callNotesContentInput ?? "").trim();
        const specialNotesText = String(callNotesSpecialNotesInput ?? "").trim();
        if (!selectedCallStatusType) {
            toast.error("Please select call status.");
            return;
        }
        if (!callNotesText) {
            toast.error("Please enter notes.");
            return;
        }
        if (isCallStatusNotInterested(selectedCallStatusType)) {
            const selectedReasonId = String(callNotesSelectedNotInterestedReasonId ?? "").trim();
            if (!selectedReasonId) {
                toast.error("Please select a reason.");
                return;
            }
        }
        const scheduledDateTimeIso = shouldShowCallNotesScheduleDateAndTimeFields(
            selectedCallStatusType
        )
            ? buildCallNotesScheduledIsoFromDateAndTime(callNotesScheduledDateTimeValue)
            : null;
        const showCompletedDateFields =
            shouldShowCallNotesDrugTestAndDotCompletionDateFields(selectedCallStatusType);
        if (showCompletedDateFields) {
            if (!String(callNotesDrugTestAndDotCompletionDateValue ?? "").trim()) {
                toast.error("Please select Drug Test and DOT Completion Date.");
                return;
            }
        }
        const requestPayload = {
            candidateClientId,
            callStatusType: selectedCallStatusType,
            notes: callNotesText,
            scheduleDateAndTime: scheduledDateTimeIso ?? null,
            specialNotes: specialNotesText,
        };
        if (showCompletedDateFields) {
            // requestPayload.drugTestAndDotCompletionDate = buildCallNotesDateOnlyIsoFromDateInput(
            //     callNotesDrugTestAndDotCompletionDateValue
            // );
            requestPayload.drugTestAndDotCompletionDate = callNotesDrugTestAndDotCompletionDateValue
        }
        if (isExistingFedexDriver) {
            requestPayload.isExistingFedexDriver = true;
        }
        if (isDriverExperience) {
            requestPayload.drivingExperience = true;
        }
        if (isCallStatusNotInterested(selectedCallStatusType)) {
            requestPayload.reasonsId = String(
                callNotesSelectedNotInterestedReasonId ?? ""
            ).trim();
        }
        setCallNotesFormSubmitInProgress(true);
        try {
            const response = await submitCallDetailsCallStatus(requestPayload);
            const responseSucceeded =
                response?.success ||
                response?.isSuccess ||
                response?.status === "success" ||
                response?.status === true;
            if (responseSucceeded) {
                toast.success(response?.message || "Call status updated.");
                setCallNotesSelectedStatusValue("");
                setCallNotesContentInput("");
                setCallNotesScheduledDateTimeValue("");
                setCallNotesDrugTestAndDotCompletionDateValue("");
                setCallNotesSpecialNotesInput("");
                setCallNotesSelectedNotInterestedReasonId("");
                navigate(`/${urlEndPoint.schedule}`);

                // if (isCallStatusCompleted(selectedCallStatusType) || isCallStatusRtrOrEligible(selectedCallStatusType)) {
                //     navigate(`/${urlEndPoint.schedule}`);
                //     return;
                // }
                if (id && (activeTab === "2" || activeTab === "3")) {
                    try {
                        const callActivitiesResponse = await getCallInfo({ candidateId: id });
                        setCallActivities(parseCallActivitiesList(callActivitiesResponse));
                        setOtherClientActivityGroups(
                            parseOtherClientActivitiesGroups(callActivitiesResponse)
                        );
                    } catch {
                        /* optional list refresh */
                    }
                }
            }
        } finally {
            setCallNotesFormSubmitInProgress(false);
        }
    };

    const fetchCandidateDetails = async (candidateId) => {
        setLoading(true);
        const payload = {
            candidateId
        };
        try {
            const response = await getCandidateDetailsForUsingCallDetails(payload);
            const responseData = response?.data ?? response;
            if (response && responseData && typeof responseData === "object") {
                setCandidateDetails(responseData);
            } else {
                setCandidateDetails(null);
            }
        } catch {
            setCandidateDetails(null);
        }
        setLoading(false);
    };

    const handleCallDetailsDriverDetailsButtonClick = () => {
        const routeCandidateIdentifier = String(id ?? "").trim();
        if (!routeCandidateIdentifier) {
            toast.error("Candidate ID not found for driver details.");
            return;
        }
        setIsPreScreeningModalOpen(false);
        setIsDriverDetailsModalOpen(true);
    };

    const handleDriverDetailsModalClose = () => {
        setIsDriverDetailsModalOpen(false);
    };

    const handleDriverDetailsSavedRefreshCallDetailsPage = async () => {
        if (id) {
            void fetchCandidateDetails(id);
        }
        await reloadCandidateApplicationStatusTests();
    };

    const handlePreScreeningButtonClick = () => {
        if (!preScreeningCandidateClientId) {
            toast.error("Candidate ID not found for pre-screening.");
            return;
        }
        setIsPreScreeningModalOpen(true);
    };

    const handleBadFitResolutionButtonClick = () => {
       
        setIsBadFitResolutionModalOpen(true);
    };

    const handleBadFitResolutionSuccess = useCallback(async () => {
        const candidateClientId = String(
            toolbarCandidateClientId || preScreeningCandidateClientId || id || ""
        ).trim();
        if (candidateClientId) {
            await getCallDetailsUpperToolbarDetails(candidateClientId);
        }

        const callDetailsId = String(id ?? "").trim();
        if (callDetailsId) {
            await fetchCandidateDetails(callDetailsId);
        }
    }, [
        getCallDetailsUpperToolbarDetails,
        id,
        preScreeningCandidateClientId,
        toolbarCandidateClientId,
    ]);

    const handleCloseConversationModal = useCallback(() => {
        setMessageModalOpenClose(false);
        setConversationLoading(false);
        setConversationMessages([]);
        setConversationTemplates([]);
    }, []);

    const reloadConversationMessages = useCallback(async () => {
        const callDetailsId = String(id ?? "").trim();
        if (!callDetailsId) return;
        try {
            const response = await getCallDetailsConversation({ callDetailsId });
            if (response?.success === false) return;
            const parsed = parseCallDetailsConversationApiResponse(response);
            setConversationMessages(parsed.messages);
            setConversationTemplates(parsed.templates);
        } catch {
            /* keep existing messages */
        }
    }, [id]);

    const handleConversationButtonClick = useCallback(async () => {
        const callDetailsId = String(id ?? "").trim();
        if (!callDetailsId) {
            toast.error("Call details ID not found for conversation.");
            return;
        }

        setMessageModalOpenClose(true);
        setConversationLoading(true);
        setConversationMessages([]);
        setConversationTemplates([]);

        try {
            const response = await getCallDetailsConversation({ callDetailsId });
            if (response?.success === false) {
                toast.error(response?.message || "Unable to load conversation.");
                handleCloseConversationModal();
                return;
            }

            const parsed = parseCallDetailsConversationApiResponse(response);
            if (!parsed.canAccessConversation) {
                toast.error("Conversation is not available for this candidate.");
                handleCloseConversationModal();
                return;
            }

            setConversationMessages(parsed.messages);
            setConversationTemplates(parsed.templates);
        } catch {
            handleCloseConversationModal();
            toast.error("Unable to load conversation.");
        } finally {
            setConversationLoading(false);
        }
    }, [id, handleCloseConversationModal]);

    const handleCloseAiCallScheduledModal = useCallback(() => {
        setAiCallScheduledModalOpen(false);
        setAiCallScheduledLoading(false);
        setAiCallScheduledRows([]);
    }, []);

    const handleAiCallScheduleDataButtonClick = useCallback(async () => {
        const callDetailsId = String(id ?? "").trim();
        if (!callDetailsId) {
            toast.error("Call details ID not found for AI call schedule data.");
            return;
        }

        setAiCallScheduledModalOpen(true);
        setAiCallScheduledLoading(true);
        setAiCallScheduledRows([]);

        try {
            const response = await getCallDetailsAiCallScheduled({ callDetailsId });
            if (response?.success === false) {
                toast.error(response?.message || "Unable to load AI call schedule data.");
                handleCloseAiCallScheduledModal();
                return;
            }
            setAiCallScheduledRows(extractAiCallScheduledRowsFromApiResponse(response));
        } catch {
            handleCloseAiCallScheduledModal();
            toast.error("Unable to load AI call schedule data.");
        } finally {
            setAiCallScheduledLoading(false);
        }
    }, [id, handleCloseAiCallScheduledModal]);

    const aiCallScheduledCandidateName = useMemo(() => {
        const name = `${candidateDetails?.firstName ?? ""} ${candidateDetails?.lastName ?? ""}`.trim();
        return name || "";
    }, [candidateDetails?.firstName, candidateDetails?.lastName]);

    const showAiCallScheduleDataButton =
        toolbarData?.showAiCallScheduleData ?? toolbarData?.showConversation;

    const showAiCallRequestButton =
        toolbarData?.showAiCallRequest ?? toolbarData?.showConversation;

    const isBadFitResolutionToolbarMode = Boolean(toolbarData?.showBadFitResolution);

    const aiCallRequestCandidateId = useMemo(() => {
        const fromDetails = String(candidateDetails?.candidateId ?? "").trim();
        if (fromDetails) return fromDetails;
        const fromTests = String(candidateTestsApiCandidateId ?? "").trim();
        if (fromTests) return fromTests;
        return String(id ?? "").trim();
    }, [candidateDetails?.candidateId, candidateTestsApiCandidateId, id]);

    const handleAiCallRequestButtonClick = useCallback(() => {
        if (!aiCallRequestCandidateId) {
            toast.error("Candidate ID not found for AI call request.");
            return;
        }
        setAiCallRequestModalOpen(true);
    }, [aiCallRequestCandidateId]);

    const handleCloseAiCallRequestModal = useCallback(() => {
        if (aiCallRequestSubmitting) return;
        setAiCallRequestModalOpen(false);
    }, [aiCallRequestSubmitting]);

    const handleConfirmAiCallRequest = useCallback(async ({ aiAddOnCallTemplateId, status } = {}) => {
        const candidateClientId = String(
            candidateDetails?.id ??
                candidateTestsApiCandidateClientId ??
                id ??
                ""
        ).trim();
        if (!candidateClientId) {
            toast.error("Candidate ID not found for AI call request.");
            return;
        }

        const templateId = String(aiAddOnCallTemplateId ?? "").trim();

        setAiCallRequestSubmitting(true);
        try {
            const response = await triggerAiRecruiterCall({
                candidateClientId,
                status: String(status ?? "").trim(),
                ...(templateId ? { aiAddOnCallTemplateId: templateId } : {}),
            });
            if (response?.success === false) {
                toast.error(response?.message || "Unable to trigger AI call.");
                return;
            }
            if (
                response?.success ||
                response?.isSuccess ||
                response?.data != null
            ) {
                toast.success(response?.message || "AI call request submitted successfully.");
                setAiCallRequestModalOpen(false);
            }
        } catch {
            toast.error("Unable to trigger AI call.");
        } finally {
            setAiCallRequestSubmitting(false);
        }
    }, [candidateDetails?.id, candidateTestsApiCandidateClientId, id]);

    const resolveAiRecruiterCandidateClientId = useCallback(() => {
        return String(
            candidateDetails?.id ??
                candidateTestsApiCandidateClientId ??
                id ??
                ""
        ).trim();
    }, [candidateDetails?.id, candidateTestsApiCandidateClientId, id]);

    const handleAiRecruiterOptInSuccess = useCallback(() => {
        setCandidateDetails((previous) =>
            previous && typeof previous === "object"
                ? { ...previous, isAIRecruiterOptedIn: true }
                : previous
        );
        if (id) {
            void fetchCandidateDetails(id);
        }
    }, [id]);

    const handleAiRecruiterOptOutSuccess = useCallback(() => {
        setCandidateDetails((previous) =>
            previous && typeof previous === "object"
                ? { ...previous, isAIRecruiterOptedIn: false }
                : previous
        );
        if (id) {
            void fetchCandidateDetails(id);
        }
    }, [id]);

    const handleAiRecruiterOptInPillClick = useCallback(async () => {
        const candidateClientId = resolveAiRecruiterCandidateClientId();
        if (!candidateClientId) {
            toast.error("Candidate ID not found.");
            return;
        }

        const confirmation = await Swal.fire({
            title: "Resume AI Recruiter?",
            text: "Are you sure you want to resume AI Recruiter for this candidate?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        });

        if (!confirmation?.isConfirmed) return;

        setAiRecruiterOptInSubmitting(true);
        try {
            const response = await candidateAiRecruiterOptIn(candidateClientId);
            const responseSucceeded =
                response?.success ||
                response?.isSuccess ||
                response?.status === "success" ||
                response?.status === true;
            if (responseSucceeded) {
                toast.success(response?.message || "AI Recruiter resumed.");
                handleAiRecruiterOptInSuccess();
            }
        } finally {
            setAiRecruiterOptInSubmitting(false);
        }
    }, [resolveAiRecruiterCandidateClientId, handleAiRecruiterOptInSuccess]);

    const handleAiRecruiterOptOutPillClick = useCallback(() => {
        const candidateClientId = resolveAiRecruiterCandidateClientId();
        if (!candidateClientId) {
            toast.error("Candidate ID not found.");
            return;
        }
        setAiRecruiterOptOutModalOpen(true);
    }, [resolveAiRecruiterCandidateClientId]);

    const handleAiRecruiterOptInStatusPillClick = useCallback(() => {
        if (Boolean(candidateDetails?.isAIRecruiterOptedIn)) {
            handleAiRecruiterOptOutPillClick();
            return;
        }
        void handleAiRecruiterOptInPillClick();
    }, [
        candidateDetails?.isAIRecruiterOptedIn,
        handleAiRecruiterOptOutPillClick,
        handleAiRecruiterOptInPillClick,
    ]);

    const clientInfoDisplaySections = useMemo(
        () =>
            buildCallDetailsClientInfoDisplaySections(callDetailsClientInfo, {
                canViewFadvLoginDetails,
            }),
        [callDetailsClientInfo, canViewFadvLoginDetails]
    );

    const clientIncentiveMetrics = useMemo(
        () => buildCallDetailsClientIncentiveMetrics(callDetailsClientInfo),
        [callDetailsClientInfo]
    );

    const clientFieldLine = (label, value, k = label) => (
        <div key={k} className="cd-field-line">
            <span className="cd-field-label">{label}:</span>{" "}
            <span className="cd-field-value">
                {value != null && String(value).trim() !== "" ? String(value) : "—"}
            </span>
        </div>
    );

    const displaySensitive = (raw, visible) => {
        if (raw == null || String(raw).trim() === "") return "—";
        return visible ? String(raw) : "••••••••";
    };

    const hasSensitiveValue = (raw) => raw != null && String(raw).trim() !== "";

    const renderClientInfoSensitiveField = (sectionTitle, field) => {
        const isPassword = field?.sensitiveKey === "password";
        const isVisible = isPassword ? showFadvPassword : showFadvSecret;
        const toggleVisibility = () =>
            isPassword
                ? setShowFadvPassword(previous => !previous)
                : setShowFadvSecret(previous => !previous);

        return (
            <p
                key={`${sectionTitle}-${field.key}`}
                className="d-flex align-items-center flex-wrap gap-2 mb-2"
            >
                <strong className="mb-0">{field.label} :</strong>
                <span className="text-break">
                    {displaySensitive(field.value, isVisible)}
                </span>
                {hasSensitiveValue(field.value) ? (
                    <i
                        className={`mdi ${isVisible ? "mdi-eye-off" : "mdi-eye"} font-size-18 cursor-pointer text-muted`}
                        role="button"
                        tabIndex={0}
                        aria-label={isVisible ? `Hide ${field.label}` : `Show ${field.label}`}
                        onClick={toggleVisibility}
                        onKeyDown={event => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                toggleVisibility();
                            }
                        }}
                    />
                ) : null}
            </p>
        );
    };

    const renderClientInfoSectionFields = (sectionTitle, fields) => {
        if (!Array.isArray(fields) || !fields.length) {
            return <p className="text-muted mb-0">—</p>;
        }

        return fields.map(field => {
            if (field?.sensitiveKey) {
                return renderClientInfoSensitiveField(sectionTitle, field);
            }

            return clientFieldLine(
                field.label,
                field.value,
                `${sectionTitle}-${field.key}`
            );
        });
    };

    return (
        <div className="page-content call-details call-details-new">
            <Container fluid>

                {/* ================= HEADER ================= */}
                <header className="cd-page-header mb-4">
                    <Row className="align-items-center g-3">
                        <Col xs="12" md>
                            <h1 className="cd-page-title h4 mb-1">Call Details</h1>
                            <p className="cd-page-subtitle text-muted mb-0 small">
                                Review candidate profile, application status, and client information.
                            </p>
                        </Col>
                        <Col xs="12" md="auto" className="text-md-end">
                            <div className="d-inline-flex flex-wrap gap-2 justify-content-md-end">
                                {toolbarData?.showPreScreening ?
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handlePreScreeningButtonClick}
                                    >
                                        <i className="mdi mdi-clipboard-text-outline me-1" />
                                        Pre Screening
                                    </Button> : null
                                }
                                {toolbarData?.showDriverDetails ?
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleCallDetailsDriverDetailsButtonClick}
                                    >
                                        <i className="mdi mdi-card-account-details-outline me-1" />
                                        Driver Details
                                    </Button> : null
                                }
                                {toolbarData?.showConversation ?
                                    <Button
                                        color="success"
                                        type="button"
                                        className="cd-conversation-btn position-relative"
                                        onClick={handleConversationButtonClick}
                                        disabled={conversationLoading}
                                    >
                                        <i className="mdi mdi-message-text-outline me-1" />
                                        Conversation
                                        {unreadConversationCount > 0 ? (
                                            <span
                                                className="cd-conversation-unread-badge"
                                                title={`${unreadConversationCount} unread conversation${unreadConversationCount === 1 ? "" : "s"}`}
                                            >
                                                {unreadConversationCount > 99
                                                    ? "99+"
                                                    : unreadConversationCount}
                                            </span>
                                        ) : null}
                                    </Button> : null
                                }
                                {fadvOrderPlaceFile ?
                                    <a
                                        className="btn btn-info"
                                        href={`${fadvOrderPlaceFile}/inline`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="mdi mdi-file-document-outline me-1" />
                                        View Application File
                                    </a> : null
                                }
                                {showAiCallScheduleDataButton ?
                                    <Button
                                        color="warning"
                                        type="button"
                                        onClick={handleAiCallScheduleDataButtonClick}
                                        disabled={aiCallScheduledLoading}
                                    >
                                        <i className="mdi mdi-calendar-clock-outline me-1" />
                                        AI Call Schedule Data
                                    </Button> : null
                                }
                                {showAiCallRequestButton ?
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleAiCallRequestButtonClick}
                                        disabled={aiCallRequestSubmitting}
                                    >
                                        <i className="mdi mdi-phone-voip me-1" />
                                        AI Call Request
                                    </Button> : null
                                }
                                {/* {toolbarData?.showBadFitResolution ?
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleBadFitResolutionButtonClick}
                                    >
                                        <i className="mdi mdi-account-alert-outline me-1" />
                                        Bad Fit Resolution
                                    </Button> : null
                                } */}

                            </div>
                        </Col>
                    </Row>
                </header>
                {candidateDetails?.callStatusReasonsId ?
                    <div className="fadv-csv-log-page">
                        <p className="fadv-csv-log-note mb-4 fadv-casv-special-reasons">
                            <i className="mdi mdi-information-outline fadv-csv-log-note__icon" aria-hidden />
                            <span className="fadv-csv-log-note__content">
                                <strong>Status Reasons :  </strong>  {candidateDetails?.callStatusReasonTitle}
                            </span>
                        </p>
                    </div> : null
                }

                {/* ================= ACCORDIONS ================= */}
                <Accordion
                    open={personalAndApplicationAccordionOpenIds}
                    toggle={togglePersonalAndApplicationAccordionSection}
                >

                    {/* -------- Personal Information -------- */}
                    <AccordionItem>
                        <AccordionHeader targetId="1">
                            <span className="accordion-bar green" />
                            Personal Information
                        </AccordionHeader>
                        <AccordionBody accordionId="1">
                            {candidateDetails ?
                                <div className="padding-lft cd-personal-section">

                                    {/* ===== Header: name + badge | copy personal info ===== */}
                                    <div className="cd-personal-head mb-4">
                                        <div className="cd-personal-head-left">
                                            <div className="cd-personal-identity-row">
                                                <span className="cd-candidate-name">
                                                    {loading ? (
                                                        <span className="placeholder-glow">
                                                            <span className="placeholder col-6" />
                                                        </span>
                                                    ) : (
                                                        <CopyablePersonalInfoValue
                                                            value={`${candidateDetails?.firstName ?? ""} ${candidateDetails?.lastName ?? ""}`.trim()}
                                                            toastLabel="candidate name"
                                                        >
                                                            <span>
                                                                {`${candidateDetails?.firstName ?? ""}  ${candidateDetails?.lastName ?? ""}`.trim() || "—"}
                                                                {" "}
                                                            </span>
                                                        </CopyablePersonalInfoValue>
                                                    )}
                                                </span>
                                                <span className="cd-candidate-name">
                                                <Badge
                                                                color={statusBadgeColor(candidateDetails?.status)}
                                                                className="badge-padding text-capitalize ms-0 align-middle"
                                                            >
                                                                {candidateDetails?.status}
                                                            </Badge>
                                                            </span>
                                                {(!loading && toolbarData?.clientIsAiRecruiterEnabled)
                                                    ? renderPersonalInfoCandidateAiRecruiterBadge(
                                                          toolbarData?.clientIsAiRecruiterEnabled,
                                                          candidateDetails?.isAIRecruiterOptedIn,
                                                          { matchCandidateStatusBadge: true }
                                                      )
                                                    : null}
                                                {!loading && clientIncentiveMetrics.length > 0 ? (
                                                    <div
                                                        className="cd-client-incentive-metrics"
                                                        aria-label="Client incentive metrics"
                                                    >
                                                        {callDetailsClientInfoLoading ? (
                                                            <div className="cd-client-incentive-metrics__loading placeholder-glow">
                                                                <span className="placeholder col-8" />
                                                            </div>
                                                        ) : (
                                                            clientIncentiveMetrics.map((metric, index) => (
                                                                <React.Fragment key={metric.key}>
                                                                    {index > 0 ? (
                                                                        <span
                                                                            className="cd-client-incentive-metric__divider"
                                                                            aria-hidden
                                                                        />
                                                                    ) : null}
                                                                    <span className="cd-client-incentive-metric">
                                                                        <i
                                                                            className={`cd-client-incentive-metric__icon ${metric.icon}`}
                                                                            aria-hidden
                                                                        />
                                                                        <span className="cd-client-incentive-metric__label">
                                                                            {metric.label}
                                                                        </span>
                                                                        <span className="cd-client-incentive-metric__value">
                                                                            {metric.value}
                                                                        </span>
                                                                    </span>
                                                                </React.Fragment>
                                                            ))
                                                        )}
                                                    </div>
                                                ) : null}
                                                {!loading && toolbarData?.clientIsAiRecruiterEnabled 
                                                    ? renderPersonalInfoAiRecruiterOptInPill({
                                                          isAIRecruiterOptedIn:
                                                              candidateDetails?.isAIRecruiterOptedIn,
                                                          onClick:
                                                              handleAiRecruiterOptInStatusPillClick,
                                                          disabled: aiRecruiterOptInSubmitting,
                                                      })
                                                    : null}
                                            </div>
                                        </div>
                                        {!loading ? (
                                            <div className="cd-personal-head-right">
                                                <div
                                                    className={classnames(
                                                        "cd-personal-copy-wrap",
                                                        {
                                                            "cd-personal-copy-wrap--active":
                                                                Boolean(personalInfoCopiedTooltipMessage),
                                                        }
                                                    )}
                                                >
                                                    {personalInfoCopiedTooltipMessage ? (
                                                        <span
                                                            className="cd-personal-copy-tooltip"
                                                            role="status"
                                                            aria-live="polite"
                                                        >
                                                            {personalInfoCopiedTooltipMessage}
                                                        </span>
                                                    ) : null}
                                                    <button
                                                        type="button"
                                                        className="cd-personal-copy-btn"
                                                        aria-label="Copy candidate name, client name, phone, and email"
                                                        title="Copy name, client, phone, and email"
                                                        onClick={handleCopyPersonalInfoBundle}
                                                    >
                                                        <i className="mdi mdi-content-copy" aria-hidden />
                                                    </button>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="cd-fields-grid mb-2">
                                        <div
                                            className="cd-personal-client-panel-box mb-0"
                                            aria-label="Client information"
                                        >
                                            <Row className="cd-fields-row cd-personal-client-row mb-0 align-items-md-center">
                                                <Col md="4" className="cd-field-col">
                                                    <InfoField label="Client Name">
                                                        <span className="d-inline-flex align-items-center flex-wrap gap-2">
                                                            <CopyablePersonalInfoValue
                                                                value={pickFirstNonEmptyString(
                                                                    candidateDetails?.clientName,
                                                                    candidateDetails?.ClientName
                                                                )}
                                                                toastLabel="client name"
                                                            >
                                                                {displayText(candidateDetails?.clientName)}
                                                            </CopyablePersonalInfoValue>
                                                            {renderPersonalInfoClientAiRecruiterBadge(
                                                                toolbarData?.clientIsAiRecruiterEnabled
                                                            )}
                                                        </span>
                                                    </InfoField>
                                                </Col>
                                                <Col md="4" className="cd-field-col">
                                                    <InfoField label="Last Update Send">
                                                        {formatCallActivityDateTime(
                                                            pickFirstNonEmptyString(
                                                                candidateDetails?.lastClientUpdateSentDateTime,
                                                                candidateDetails?.LastClientUpdateSentDateTime
                                                            ) || null
                                                        )}
                                                    </InfoField>
                                                </Col>
                                                <Col md="4" className="cd-field-col">
                                                    <InfoField label="AI Schedule">
                                                        {personalInfoFieldOrNa(
                                                            candidateDetails?.aiScheduleGroup,
                                                            candidateDetails?.AiScheduleGroup
                                                        )}
                                                    </InfoField>
                                                </Col>
                                            </Row>
                                        </div>
                                        {/* <hr className="cd-personal-client-divider" /> */}

                                        <Row className="cd-fields-row cd-personal-details-first-row mt-4">
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Email">
                                                    <InlineEditableField
                                                        value={personalInfo.email}
                                                        onSave={handleEmailSave}
                                                        validate={validateCallDetailsPersonalEmail}
                                                        saving={personalInfoSavingField === "email"}
                                                        inputProps={{
                                                            type: "text",
                                                            inputMode: "email",
                                                            autoComplete: "email",
                                                            placeholder: "Email",
                                                        }}
                                                    />
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Phone">
                                                    <CopyablePersonalInfoValue
                                                        value={pickFirstNonEmptyString(
                                                            candidateDetails?.phone,
                                                            candidateDetails?.phoneNumber
                                                        )}
                                                        toastLabel="phone"
                                                    >
                                                        {personalInfoFieldOrNa(
                                                            phoneNumberShowFormat(
                                                                pickFirstNonEmptyString(
                                                                    candidateDetails?.phone,
                                                                    candidateDetails?.phoneNumber
                                                                )
                                                            )
                                                        )}
                                                    </CopyablePersonalInfoValue>
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Date Added">
                                                    {formatDateAdded(candidateDetails?.createAt)}
                                                </InfoField>
                                            </Col>
                                        </Row>

                                        <Row className="cd-fields-row">
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Source">
                                                    {displayText(candidateDetails?.sourceName)}
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Order Status">
                                                    <StatusMetadataBadge
                                                        accessor="orderStatus"
                                                        pageName="call-details"
                                                        value={pickFirstNonEmptyString(
                                                            candidateDetails?.orderStatus
                                                        )}
                                                        className={PERSONAL_INFO_STATUS_METADATA_BADGE_CLASS}
                                                        emptyPlaceholder="—"
                                                    />
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="FADV Job Title">
                                                    {personalInfoFieldOrNa(
                                                        fadvPanelRecord?.fadvJobTitle,
                                                        fadvPanelRecord?.FadvJobTitle,
                                                        candidateDetails?.fadvJobTitle,
                                                        candidateDetails?.FadvJobTitle
                                                    )}
                                                </InfoField>
                                            </Col>
                                        </Row>

                                        <Row className="cd-fields-row">
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="FADV Job Status">
                                                    {personalInfoFieldOrNa(
                                                        fadvPanelRecord?.fadvJobStatus,
                                                        fadvPanelRecord?.FadvJobStatus,
                                                        candidateDetails?.fadvJobStatus,
                                                        candidateDetails?.FadvJobStatus
                                                    )}
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="FADV Profile ID">
                                                    {personalInfoFieldOrNa(
                                                        candidateDetails?.fadvProfileId,
                                                        candidateDetails?.FadvProfileId
                                                    )}
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Post Applied For">
                                                    {renderPersonalInfoJobNameBadge(
                                                        candidateDetails?.jobName
                                                    )}
                                                </InfoField>
                                            </Col>
                                        </Row>

                                        <Row className="cd-fields-row">
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Facility">
                                                    {personalInfoFieldOrNa(
                                                        candidateDetails?.facilityId
                                                    )}
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Order ID BG">
                                                    {candidateDetails?.orderIdBG || 'N/A'}
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Recruiter">
                                                    {candidateDetails?.recruiterName || 'AI Recruiter'}
                                                </InfoField>
                                            </Col>
                                        </Row>

                                        <Row className="cd-fields-row">
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="FedEx ID">
                                                    <InlineEditableField
                                                        value={personalInfo.fedexId}
                                                        onSave={handleFedexIdSave}
                                                        saving={personalInfoSavingField === "fedexId"}
                                                        inputProps={{
                                                            placeholder: "FedEx ID",
                                                        }}
                                                    />
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Job Acceptance">
                                                    {renderPersonalInfoJobAcceptanceBadge(candidateDetails)}
                                                </InfoField>
                                            </Col>
                                            <Col md="4" className="cd-field-col">
                                                <InfoField label="Update Send">
                                                    {renderPersonalInfoUpdateSend(candidateDetails)}
                                                </InfoField>
                                            </Col>
                                        </Row>
                                        <Row className="cd-fields-row row">
                                            <Col md="4" className="cd-field-col col-md-4">
                                                <div className="cd-field-line d-flex align-items-center flex-wrap gap-2 mt-1">
                                                    <Label className="cd-field-label mb-0" for="send-fadv-link-select">
                                                        Send FADV link?
                                                    </Label>
                                                    <Input
                                                        id="send-fadv-link-select"
                                                        type="select"
                                                        bsSize="sm"
                                                        className="cd-send-fadv-link-select"
                                                        style={{ maxWidth: "71px" }}
                                                        value={sendFadvLinkSelectValue}
                                                        disabled={
                                                            sendFadvLinkOptionsLoading ||
                                                            sendFadvLinkSaving ||
                                                            !sendFadvLinkYesNoOptions.length
                                                        }
                                                        onChange={(e) => {
                                                            void handleSendFadvLinkSelectChange(e);
                                                        }}
                                                    >
                                                        {sendFadvLinkYesNoOptions.map((opt) => (
                                                            <option key={String(opt.value)} value={String(opt.value)}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </Col>
                                            {/* <Col md="4" className="cd-field-col">
                                                <InfoField label="Update Send">
                                                    {renderPersonalInfoUpdateSend(candidateDetails)}
                                                </InfoField>
                                            </Col> */}
                                            {/* <Col md="4" className="cd-field-col" aria-hidden="true" /> */}
                                        </Row>
                                    </div>

                                    {/* ===== Quota + Job portal: equal width/height grid, aligned labels ===== */}
                                    <div className="cd-slots-pair mt-2 pt-2">
                                        <h6 className="cd-slots-title cd-slots-title-a">
                                            Quota
                                        </h6>
                                        <h6 className="cd-slots-title cd-slots-title-b">
                                            Job Portal Link
                                        </h6>

                                        <div className="quota-box form-control cd-slots-field cd-slots-field-a d-flex align-items-center flex-wrap gap-3 cd-quota-checkboxes">
                                            <FormGroup check className="mb-0 cd-quota-fedex-check">
                                                <Input
                                                    key={`quota-fedex-driver-${id ?? ""}-${fedexCheckboxKey}`}
                                                    id="quota-fedex-driver"
                                                    type="checkbox"
                                                    defaultChecked={fedexDefaultChecked}
                                                    onChange={async (event) => {
                                                        if (event.target.checked) {
                                                            pendingFedexOpenRef.current = true;
                                                            setFedexModalOpen(true);
                                                            setFedexDefaultChecked(true);
                                                        } else {
                                                            const isFedexDriverFromApi =
                                                                resolveIsFedexDriverDefaultChecked(
                                                                    candidateDetails
                                                                );
                                                            if (!isFedexDriverFromApi) {
                                                                setFedexDefaultChecked(false);
                                                                setIsExistingFedexDriver(false);
                                                                setFedexCheckboxKey(
                                                                    (previousFedexCheckboxKey) =>
                                                                        previousFedexCheckboxKey + 1
                                                                );
                                                                return;
                                                            }
                                                            const confirmation = await Swal.fire({
                                                                title: "Uncheck Existing FedEx Driver?",
                                                                text:
                                                                    "Unchecking will reset this candidate and remove their Existing FedEx Driver status. This action cannot be undone. Do you want to continue?",
                                                                icon: "warning",
                                                                customClass: {
                                                                    icon: "swal2-danger-round-icon",
                                                                },
                                                                showCancelButton: true,
                                                                confirmButtonText: "Yes, uncheck",
                                                                confirmButtonColor: "#dc3545",
                                                                cancelButtonText: "Cancel",
                                                                cancelButtonColor: "#6c757d",
                                                                reverseButtons: true,
                                                            });
                                                            if (!confirmation?.isConfirmed) {
                                                                setFedexDefaultChecked(true);
                                                                setFedexCheckboxKey(
                                                                    (previousFedexCheckboxKey) =>
                                                                        previousFedexCheckboxKey + 1
                                                                );
                                                                return;
                                                            }
                                                            const candidateClientId =
                                                                candidateDetails?.id != null
                                                                    ? String(candidateDetails.id).trim()
                                                                    : "";
                                                            if (!candidateClientId) {
                                                                toast.error("Candidate is not loaded.");
                                                                setFedexDefaultChecked(true);
                                                                setFedexCheckboxKey(
                                                                    (previousFedexCheckboxKey) =>
                                                                        previousFedexCheckboxKey + 1
                                                                );
                                                                return;
                                                            }
                                                            const response =
                                                                await uncheckExistingFedexDriverForCallDetails({
                                                                    candidateClientId,
                                                                });
                                                            const responseSucceeded =
                                                                response?.success ||
                                                                response?.isSuccess ||
                                                                response?.status === "success" ||
                                                                response?.status === true;
                                                            if (responseSucceeded) {
                                                                toast.success(
                                                                    response?.message ||
                                                                        "Existing FedEx Driver unchecked."
                                                                );
                                                                setFedexDefaultChecked(false);
                                                                setIsExistingFedexDriver(false);
                                                                setFedexCheckboxKey(
                                                                    (previousFedexCheckboxKey) =>
                                                                        previousFedexCheckboxKey + 1
                                                                );
                                                                void fetchCandidateDetails(id);
                                                            } else {
                                                                toast.error(
                                                                    response?.message || "Request failed."
                                                                );
                                                                setFedexDefaultChecked(true);
                                                                setFedexCheckboxKey(
                                                                    (previousFedexCheckboxKey) =>
                                                                        previousFedexCheckboxKey + 1
                                                                );
                                                            }
                                                        }
                                                    }}
                                                />{" "}
                                                <Label check for="quota-fedex-driver">
                                                    Is Existing FedEx Driver
                                                    {resolveIsFedexDriverDefaultChecked(
                                                        candidateDetails
                                                    ) ? (
                                                        <button
                                                            type="button"
                                                            className="cd-quota-fedex-edit-btn"
                                                            aria-label="Edit FedEx existing driver"
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                setFedexModalOpen(true);
                                                            }}
                                                        >
                                                            <i
                                                                className="mdi mdi-pencil-outline"
                                                                aria-hidden="true"
                                                            />
                                                        </button>
                                                    ) : null}
                                                </Label>
                                            </FormGroup>

                                            <FormGroup check className="mb-0">
                                                <Input
                                                    key={`quota-driving-experience-${id ?? ""}-${drivingExpCheckboxKey}`}
                                                    id="quota-driving-experience"
                                                    type="checkbox"
                                                    defaultChecked={drivingExpDefaultChecked}
                                                    onChange={(event) => {
                                                        if (event.target.checked) {
                                                            pendingDrivingExpOpenRef.current = true;
                                                            setDrivingExpModalOpen(true);
                                                        } else {
                                                            setDrivingExpDefaultChecked(false);
                                                            setIsDriverExperience(false);
                                                            setDrivingExpCheckboxKey(
                                                                (previousDrivingExperienceCheckboxKey) =>
                                                                    previousDrivingExperienceCheckboxKey + 1
                                                            );
                                                        }
                                                    }}
                                                />
                                                <Label check for="quota-driving-experience">
                                                    Driving Experience
                                                </Label>
                                            </FormGroup>
                                        </div>

                                        <div
                                            className={classnames(
                                                "cd-slots-field cd-slots-field-b cd-job-portal-slot cd-job-portal-slot--link cursor-pointer",
                                                { "cd-job-portal-slot--clickable": Boolean(jobPortalLink) }
                                            )}
                                            role={jobPortalLink ? "button" : undefined}
                                            tabIndex={jobPortalLink ? 0 : undefined}
                                            onClick={jobPortalLink ? handleCopyJobPortalLink : undefined}
                                            onKeyDown={
                                                jobPortalLink
                                                    ? (event) => {
                                                        if (event.key === "Enter" || event.key === " ") {
                                                            event.preventDefault();
                                                            handleCopyJobPortalLink();
                                                        }
                                                    }
                                                    : undefined
                                            }
                                        >
                                            <Input
                                                readOnly
                                                plaintext
                                                className="cd-job-portal-input cursor-pointer"
                                                value={jobPortalLink || "N/A"}
                                            />
                                            {jobPortalLink ? (
                                                <button
                                                    type="button"
                                                    className="cd-job-portal-copy-btn"
                                                    aria-label="Copy job portal link"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleCopyJobPortalLink();
                                                    }}
                                                >
                                                    <i className="mdi mdi-content-copy" aria-hidden />
                                                </button>
                                            ) : null}
                                        </div>

                                        <h6 className="cd-slots-title cd-slots-title-c cd-slots-title-with-count">
                                            <span>Candidate Dashboard Link</span>
                                            {dashboardLinkSendCount !== null &&
                                            !Number.isNaN(dashboardLinkSendCount) ? (
                                                <span
                                                    className="cd-dashboard-link-send-count"
                                                    title="Dashboard link send count"
                                                >
                                                    {dashboardLinkSendCount}
                                                </span>
                                            ) : null}
                                        </h6>

                                        <div
                                            className={classnames(
                                                "cd-slots-field cd-slots-field-c cd-job-portal-slot cd-job-portal-slot--link cursor-pointer",
                                                { "cd-job-portal-slot--clickable": Boolean(candidateDashboardLink) }
                                            )}
                                            role={candidateDashboardLink ? "button" : undefined}
                                            tabIndex={candidateDashboardLink ? 0 : undefined}
                                            onClick={candidateDashboardLink ? handleCopyCandidateDashboardLink : undefined}
                                            onKeyDown={
                                                candidateDashboardLink
                                                    ? (event) => {
                                                        if (event.key === "Enter" || event.key === " ") {
                                                            event.preventDefault();
                                                            handleCopyCandidateDashboardLink();
                                                        }
                                                    }
                                                    : undefined
                                            }
                                        >
                                            <Input
                                                readOnly
                                                plaintext
                                                className="cd-job-portal-input cursor-pointer"
                                                value={candidateDashboardLink || "N/A"}
                                            />
                                            {candidateDashboardLink ? (
                                                <button
                                                    type="button"
                                                    className="cd-job-portal-copy-btn can-dashboard-wd-ht"
                                                    aria-label="Copy candidate dashboard link"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleCopyCandidateDashboardLink();
                                                    }}
                                                >
                                                    <i className="mdi mdi-content-copy" aria-hidden />
                                                </button>
                                            ) : null}
                                            {candidateDashboardSendAction ? (
                                                <button
                                                    type="button"
                                                    className="cd-job-portal-send-btn"
                                                    aria-label={
                                                        candidateDashboardSendAction?.label ||
                                                        "Send candidate dashboard link"
                                                    }
                                                    title={
                                                        candidateDashboardSendAction?.label ||
                                                        "Send candidate dashboard link"
                                                    }
                                                    disabled={
                                                        toolbarPageActionSubmittingKind ===
                                                        candidateDashboardSendAction?.kind
                                                    }
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleToolbarPageActionClick(
                                                            candidateDashboardSendAction
                                                        );
                                                    }}
                                                >
                                                    <i
                                                        className={
                                                            toolbarPageActionSubmittingKind ===
                                                            candidateDashboardSendAction?.kind
                                                                ? "fas fa-spinner fa-spin"
                                                                : "fas fa-paper-plane"
                                                        }
                                                        aria-hidden
                                                    />
                                                </button>
                                            ) : null}
                                        </div>

                                        {sendInterviewLinkAction ? (
                                            <>
                                                <h6 className="cd-slots-title cd-slots-title-d">
                                                   Send Interview Link ?
                                                </h6>

                                                <div className="cd-slots-field cd-slots-field-d cd-job-portal-slot cd-job-portal-slot--link">
                                                    <Input
                                                        readOnly
                                                        plaintext
                                                        className="cd-job-portal-input"
                                                        value={interviewLinkDisplayValue}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="cd-job-portal-send-btn"
                                                        aria-label={
                                                            sendInterviewLinkAction?.label ||
                                                            "Send interview link"
                                                        }
                                                        title={
                                                            sendInterviewLinkAction?.label ||
                                                            "Send interview link"
                                                        }
                                                        disabled={
                                                            toolbarPageActionSubmittingKind ===
                                                            sendInterviewLinkAction?.kind
                                                        }
                                                        onClick={() =>
                                                            handleToolbarPageActionClick(
                                                                sendInterviewLinkAction
                                                            )
                                                        }
                                                    >
                                                        <i
                                                            className={
                                                                toolbarPageActionSubmittingKind ===
                                                                sendInterviewLinkAction?.kind
                                                                    ? "fas fa-spinner fa-spin"
                                                                    : "fas fa-paper-plane"
                                                            }
                                                            aria-hidden
                                                        />
                                                    </button>
                                                </div>
                                            </>
                                        ) : null}
                                    </div>

                                </div> :
                                <div className="padding-lft cd-personal-loading py-4">
                                    <Loaders />
                                </div>
                            }

                        </AccordionBody>
                    </AccordionItem>
                    {candidateDetails?.clientFeedback ? (
                                                    <div className="cd-client-feedback mb-4">
                                                        <h6 className="fw-bold mb-2">Client Feedback</h6>
                                                        <div className="cd-client-feedback__body text-break">
                                                            {candidateDetails?.clientFeedback}
                                                        </div>
                                                    </div>
                                                ) : null}

                    {/* -------- Driver profile metadata (FEC) -------- */}
                    <AccordionItem className="mt-2 cd-driver-profile-accordion-item">
                        <AccordionHeader targetId={FADV_DRIVER_PROFILE_METADATA_ACCORDION_ID}>
                            <span className="accordion-bar blue" />
                            Driver Profile (FEC)
                        </AccordionHeader>
                        <AccordionBody accordionId={FADV_DRIVER_PROFILE_METADATA_ACCORDION_ID}>
                            <CallDetailsDriverProfileMetadataSection
                                candidateClientId={driverProfileMetadataCandidateClientId}
                                rows={driverProfileMetadataRows}
                                loading={driverProfileMetadataLoading}
                                loadError={driverProfileMetadataError}
                                onRefresh={loadDriverProfileMetadata}
                            />
                        </AccordionBody>
                    </AccordionItem>

                    {/* -------- Application Status -------- */}
                    <AccordionItem className="mt-2">
                        <AccordionHeader targetId="2">
                            <span className="accordion-bar yellow" />
                            Application Status
                        </AccordionHeader>
                        <AccordionBody accordionId="2">

                            <Card className="border-0 cd-inner-card">
                                <CardBody className="pt-0 padding-lft cd-app-status-body">
                                    <div className="cd-status-stack">

                                        {/* <Row className="align-items-end mb-3">
                                        <Col md="5">
                                            <Label className="fw-semibold">Send FADV Link?</Label>
                                            <Input type="select">
                                                <option>No</option>
                                                <option>Yes</option>
                                            </Input>
                                        </Col>
                                        <Col md="5">
                                            <Label className="fw-semibold">Select FADV Package</Label>
                                            <Input type="select">
                                                <option>Select Package</option>
                                            </Input>
                                        </Col>

                                        <Col md="1">
                                            <Label className="fw-semibold">Status</Label>
                                            <div className="form-control-plaintext fw-semibold text-success">
                                                Active
                                            </div>
                                        </Col>



                                        <Col md="12" className="d-flex justify-content-end send-btn-pos">
                                            <Button color="primary">
                                                Send
                                            </Button>
                                        </Col>
                                    </Row> */}
                                        <Form className="cd-status-form" onSubmit={handleSubmit}>
                                            <div
                                                className={classnames(
                                                    "application-status-list fadv-padding-fixed cd-fadv-only-section",
                                                    isBadFitResolutionToolbarMode &&
                                                        "cd-fadv-only-section--bad-fit-mode"
                                                )}
                                            >
                                                <Row
                                                    className={classnames(
                                                        "align-items-center status-item fadv-item-hght",
                                                        isBadFitResolutionToolbarMode
                                                            ? "cd-fadv-bad-fit-row"
                                                            : "bg-light"
                                                    )}
                                                >
                                                    <Col lg="2" md="2" xs="12" className="move-fadv-title cd-fadv-lead-col">
                                                        <span className="status-title">FADV:</span>
                                                        {/* {isBadFitResolutionToolbarMode ? (
                                                            <span className="cd-fadv-disabled-badge">
                                                                Unavailable
                                                            </span>
                                                        ) : null} */}
                                                    </Col>

                                                    {isBadFitResolutionToolbarMode ? (
                                                        <Col
                                                            lg="10"
                                                            md="10"
                                                            xs="12"
                                                            className="d-flex flex-wrap align-items-center justify-content-md-end gap-2 cd-fadv-bad-fit-action-col"
                                                        >
                                                            <span className="cd-fadv-disabled-hint">
                                                            FADV actions are disabled until converted to Good Fit.
                                                            </span>
                                                            <Button
                                                                color="success"
                                                                type="button"
                                                                className="cd-fadv-bad-fit-action-btn"
                                                                onClick={handleBadFitResolutionButtonClick}
                                                            >
                                                                <i className="mdi mdi-account-alert-outline me-1" />
                                                                Convert To Good Fit
                                                            </Button>
                                                        </Col>
                                                    ) : (
                                                        <>
                                                    <Col lg="4" md="2" xs="12">
                                                        <div className="fadv-item">
                                                            <span className="status-title">Package:</span>
                                                            <Input
                                                                type="select"
                                                                value={selectedFadvPackageId}
                                                                onChange={(e) =>
                                                                    setSelectedFadvPackageId(e.target.value)
                                                                }
                                                            >
                                                                <option value="">Select Package</option>
                                                                {fadvPackageOptions.map((pkg) => {
                                                                    const optId = String(pkg.id ?? "").trim();
                                                                    if (!optId) return null;
                                                                    return (
                                                                        <option key={optId} value={optId}>
                                                                            {String(
                                                                                pkg.display ?? optId
                                                                            ).trim() || "Package"}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </Input>
                                                        </div>
                                                    </Col>

                                                    <Col lg="4" md="2" xs="12">
                                                        <div className="fadv-item">
                                                            <span className="status-title">Status:</span>
                                                            <span className={`fw-semibold ${fadvPanelRecord?.fadvApiStatus=='failed' ? 'text-danger' :'text-success'}`}>
                                                                {fadvPanelLoading
                                                                    ? "Loading…"
                                                                    : (() => {
                                                                        const ccid = String(
                                                                            candidateTestsApiCandidateClientId ??
                                                                            ""
                                                                        ).trim();
                                                                        if (!ccid) return "";
                                                                        const apiStatus = String(
                                                                            fadvPanelRecord?.fadvApiStatus ?? ""
                                                                        ).toLowerCase();
                                                                        if (
                                                                            [
                                                                                "success",
                                                                                "completed",
                                                                                "sent",
                                                                            ].some((key) => apiStatus.includes(key))
                                                                        ) {
                                                                            return fadvPanelRecord?.fadvApiStatus;
                                                                        }
                                                                        if (apiStatus) {
                                                                            return humanizeCallStatusType(
                                                                                fadvPanelRecord?.fadvApiStatus
                                                                            );
                                                                        }
                                                                        const modifiedStatus = String(
                                                                            fadvPanelRecord?.fadvApiMessage ?? ""
                                                                        ).trim();
                                                                        return modifiedStatus || "";
                                                                    })()}
                                                            </span>
                                                        </div>
                                                    </Col>

                                                    <Col lg="1" md="2" xs="3" className="text-center cd-fadv-refresh-col">
                                                        <div
                                                            className="cd-fadv-refresh-inline"
                                                            onClick={() => {
                                                                void reloadFadvPanel();
                                                            }}
                                                        >
                                                            <span className="status-title cd-fadv-refresh-label">Refresh</span>
                                                            <i className="mdi mdi-refresh fadv-refresh" aria-hidden />
                                                        </div>
                                                    </Col>

                                                    <Col lg="1" md="1" xs="12" className="cd-fadv-send-col">
                                                        <Button
                                                            color="primary"
                                                            className="w-100 uniform-btn"
                                                            onClick={() => {
                                                                void handleFadvPackageSendClick();
                                                            }}
                                                        >
                                                            <i className="fa fa-paper-plane me-1" />
                                                            Send
                                                        </Button>
                                                    </Col>
                                                        </>
                                                    )}
                                                </Row>
                                            </div>
                                        </Form>

                                            <div className="application-status-list fadv-padding-fixed">
                                                <Row className="align-items-center bg-light status-item fadv-item-hght">
                                                    <Col lg="2" md="2" xs="12" className="move-fadv-title cd-fadv-lead-col">
                                                        <span className="status-title">Profile Details:</span>
                                                    </Col>

                                                    <Col lg="4" md="2" xs="12">
                                                        <div className="fadv-item">
                                                            <span className="status-title">Last Updated Time:</span>
                                                            <span className="fw-semibold">
                                                                {profileLastUpdatedDisplay}
                                                            </span>
                                                        </div>
                                                    </Col>

                                                    <Col lg="4" md="2" xs="12">
                                                        <div className="fadv-item">
                                                            <span className="status-title">Image:</span>
                                                            {profileImagePresentation.href ? (
                                                                <a
                                                                    href={profileImagePresentation.href}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="cd-profile-image-view-link"
                                                                    title="View profile image in a new tab"
                                                                >
                                                                    <span
                                                                        className="cd-profile-image-view-link__icon"
                                                                        aria-hidden="true"
                                                                    >
                                                                        <i className="fa fa-image" />
                                                                    </span>
                                                                    <span className="cd-profile-image-view-link__text">
                                                                        View image
                                                                    </span>
                                                                    <i
                                                                        className="fa fa-external-link-alt cd-profile-image-view-link__external"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            ) : (
                                                                <span className="fw-semibold text-danger cursor-pointer">
                                                                    N/A
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Col>

                                                    <Col lg="1" md="2" xs="3" className="text-center cd-fadv-refresh-col">
                                                        <div
                                                            className="cd-fadv-refresh-inline"
                                                            onClick={() => {
                                                                void handleProfileDetailsBackgroundReload();
                                                            }}
                                                        >
                                                            <span className="status-title cd-fadv-refresh-label">Reload</span>
                                                            <i className="mdi mdi-refresh fadv-refresh" aria-hidden />
                                                        </div>
                                                    </Col>

                                                    <Col lg="1" md="1" xs="12" className="cd-fadv-send-col">
                                                        <Button
                                                            color="primary"
                                                            className="w-100 uniform-btn"
                                                            onClick={() => {
                                                                void handleProfileDetailsOrderSend();
                                                            }}
                                                        >
                                                            <i className="fa fa-paper-plane me-1" />
                                                            Send
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {shouldShowDriverDetailsSection ? (
                                                <div className="application-status-list fadv-padding-fixed">
                                                    <Row className="align-items-center bg-light status-item fadv-item-hght">
                                                        <Col lg="2" md="2" xs="12" className="move-fadv-title cd-fadv-lead-col">
                                                            <span className="status-title">Driver Details:</span>
                                                        </Col>

                                                        <Col lg="4" md="2" xs="12">
                                                            <div className="fadv-item">
                                                                <span className="status-title">Last Updated Time:</span>
                                                                <span className="fw-semibold">
                                                                    {driverLastUpdatedDisplay}
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        <Col lg="4" md="2" xs="12">
                                                            <div className="fadv-item">
                                                                <span className="status-title">Image:</span>
                                                                {driverImagePresentation.href ? (
                                                                    <a
                                                                        href={driverImagePresentation.href}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="cd-profile-image-view-link"
                                                                        title="View driver profile image in a new tab"
                                                                    >
                                                                        <span
                                                                            className="cd-profile-image-view-link__icon"
                                                                            aria-hidden="true"
                                                                        >
                                                                            <i className="fa fa-image" />
                                                                        </span>
                                                                        <span className="cd-profile-image-view-link__text">
                                                                            View image
                                                                        </span>
                                                                        <i
                                                                            className="fa fa-external-link-alt cd-profile-image-view-link__external"
                                                                            aria-hidden="true"
                                                                        />
                                                                    </a>
                                                                ) : (
                                                                    <span className="fw-semibold text-danger cursor-pointer">
                                                                        N/A
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </Col>

                                                        <Col lg="1" md="2" xs="3" className="text-center cd-fadv-refresh-col">
                                                            <div
                                                                className="cd-fadv-refresh-inline"
                                                                onClick={() => {
                                                                    void handleDriverDetailsImageReload();
                                                                }}
                                                            >
                                                                <span className="status-title cd-fadv-refresh-label">Reload</span>
                                                                <i className="mdi mdi-refresh fadv-refresh" aria-hidden />
                                                            </div>
                                                        </Col>

                                                        <Col lg="1" md="1" xs="12" className="cd-fadv-send-col">
                                                            <Button
                                                                color="primary"
                                                                className="w-100 uniform-btn"
                                                                onClick={() => {
                                                                    void handleDriverDetailsApiSend();
                                                                }}
                                                            >
                                                                <i className="fa fa-paper-plane me-1" />
                                                                Send
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ) : null}

                                        <hr />


                                        <CallDetailsCandidateApplicationStatusTestsSection
                                            callDetailsRouteParameterId={
                                                candidateTestActionBodyCandidateId
                                            }
                                            candidateTestActionBodyCandidateClientId={
                                                candidateTestActionBodyCandidateClientId
                                            }
                                            candidateTestActionBodyCandidateId={
                                                candidateTestActionBodyCandidateId
                                            }
                                            candidateApplicationStatusTestRows={
                                                candidateApplicationStatusTestRows
                                            }
                                            loading={candidateApplicationStatusTestsLoading}
                                            onCandidateApplicationStatusTestsShouldReload={
                                                reloadCandidateApplicationStatusTests
                                            }
                                            onRequestOpenDriverDetailsModal={
                                                handleCallDetailsDriverDetailsButtonClick
                                            }
                                        />

                                    </div>

                                    {/* <div className="application-status-list d-flex flex-column gap-3">

                                        <div className="status-item d-flex justify-content-between align-items-center p-3 rounded bg-warning bg-opacity-10">
                                            <div className="status-left">
                                                <span className="fw-semibold text-dark">Video Interview</span>
                                            </div>

                                            <div className="status-right d-flex align-items-center gap-2">
                                                <Button size="sm" color="primary">
                                                    Send Interview Link
                                                </Button>
                                                <i className="mdi mdi-dots-vertical fs-5 text-muted cursor-pointer" />
                                            </div>
                                        </div>

                                        <div className="status-item d-flex justify-content-between align-items-center p-3 rounded bg-success bg-opacity-10">
                                            <div className="status-left">
                                                <span className="fw-semibold text-dark">Drug Screening</span>
                                            </div>

                                            <div className="status-right d-flex align-items-center gap-2">
                                                <Badge color="success" pill>
                                                    Negative / Pass
                                                </Badge>
                                                <Button size="sm" color="primary">
                                                    Change
                                                </Button>
                                                <i className="mdi mdi-dots-vertical fs-5 text-muted cursor-pointer" />
                                            </div>
                                        </div>

                                        <div className="status-item d-flex justify-content-between align-items-center p-3 rounded bg-warning bg-opacity-10">
                                            <div className="status-left">
                                                <span className="fw-semibold text-dark">DOT Medical Card</span>
                                            </div>

                                            <div className="status-right d-flex align-items-center gap-2 flex-wrap">
                                                <Badge color="danger" pill>
                                                    Paperwork Sent
                                                </Badge>
                                                <Button size="sm" color="secondary">
                                                    Resend MEC
                                                </Button>
                                                <Button size="sm" color="primary">
                                                    Upload MEC
                                                </Button>
                                                <i className="mdi mdi-dots-vertical fs-5 text-muted cursor-pointer" />
                                            </div>
                                        </div>

                                        <div className="status-item d-flex justify-content-between align-items-center p-3 rounded bg-light">
                                            <div className="status-left">
                                                <span className="fw-semibold text-dark">Road Test</span>
                                            </div>

                                            <div className="status-right d-flex align-items-center gap-2">
                                                <Badge color="danger" pill>
                                                    Pending on Client’s End
                                                </Badge>
                                                <i className="mdi mdi-dots-vertical fs-5 text-muted cursor-pointer" />
                                            </div>
                                        </div>

                                        <div className="status-item d-flex justify-content-between align-items-center p-3 rounded bg-light">
                                            <div className="status-left">
                                                <span className="fw-semibold text-dark">Quals Cert</span>
                                            </div>

                                            <div className="status-right d-flex align-items-center gap-2">
                                                <Badge color="danger" pill>
                                                    Pending on Client’s End
                                                </Badge>
                                                <i className="mdi mdi-dots-vertical fs-5 text-muted cursor-pointer" />
                                            </div>
                                        </div>

                                    </div> */}


                                    {/* <div className="application-status-list">

                                        <div className="status-row">
                                            <div className="status-left">
                                                <span className="status-title">Video Interview:</span>
                                            </div>

                                            <div className="status-right">
                                                <Button className="action-btn" color="primary">Send Interview Link</Button>
                                                <i className="mdi mdi-dots-vertical status-dots" />
                                            </div>
                                        </div>

                                        <div className="status-row">
                                            <div className="status-left">
                                                <span className="status-title">Drug Screening:</span>
                                            </div>

                                            <div className="status-right">
                                                <Badge color="success" pill className="badge-padding">Negative/Pass</Badge>
                                                <Button className="action-btn" color="primary">Change</Button>
                                                <i className="mdi mdi-dots-vertical status-dots" />
                                            </div>
                                        </div>

                                        <div className="status-row">
                                            <div className="status-left">
                                                <span className="status-title">DOT Medical Card:</span>
                                            </div>

                                            <div className="status-right">
                                                <Badge color="danger" pill className="badge-padding">Paperwork Sent</Badge>
                                                <Button className="action-btn mec-btn-clr">Resend MEC Paperwork</Button>
                                                <Button className="action-btn" color="primary">Upload MEC</Button>
                                                <i className="mdi mdi-dots-vertical status-dots" />
                                            </div>
                                        </div>
                                        <div className="status-row">
                                            <div className="status-left">
                                                <span className="status-title">Road Test:</span>
                                            </div>

                                            <div className="status-right">
                                                <Badge color="danger" pill className="badge-padding">Pending On Client's End</Badge>
                                                <i className="mdi mdi-dots-vertical status-dots" />
                                            </div>
                                        </div>
                                        <div className="status-row">
                                            <div className="status-left">
                                                <span className="status-title">Quarls Test:</span>
                                            </div>

                                            <div className="status-right">
                                                <Badge color="danger" pill className="badge-padding">Pending On Client's End</Badge>
                                                <i className="mdi mdi-dots-vertical status-dots" />
                                            </div>
                                        </div>

                                    </div> */}


                                </CardBody>
                            </Card>


                        </AccordionBody>
                    </AccordionItem>

                </Accordion>

                {/* ================= TABS ================= */}
                <Card className="task-card mt-4 background-none cd-tabs-shell border rounded-3 shadow-sm overflow-hidden border-radius-zero">
                    <CardBody className="p-0">

                        <DragDropContext
                            onDragEnd={(result) => {
                                if (!result?.destination) return;
                                if (result.source.index === result.destination.index) return;
                                const nextOrder = [...callDetailsTabOrder];
                                const [movedTabId] = nextOrder.splice(result.source.index, 1);
                                nextOrder.splice(result.destination.index, 0, movedTabId);
                                const savedOrder = saveCallDetailsTabOrder(nextOrder);
                                setCallDetailsTabOrder(savedOrder);
                                if (savedOrder[0]) {
                                    setActiveTab(savedOrder[0]);
                                }
                            }}
                        >
                            <Droppable
                                droppableId="call-details-tabs"
                                direction="horizontal"
                                type="CALL_DETAILS_TAB"
                            >
                                {(droppableProvided) => (
                                    <ul
                                        ref={droppableProvided.innerRef}
                                        {...droppableProvided.droppableProps}
                                        className="nav nav-tabs client-tabs cd-tabs-nav"
                                    >
                                        {callDetailsTabOrder.map((tabId, index) => {
                                            const tabDefinition = CALL_DETAILS_TABS.find(
                                                (tab) => tab.id === tabId
                                            );
                                            if (!tabDefinition) return null;
                                            return (
                                                <Draggable
                                                    key={tabId}
                                                    draggableId={`call-details-tab-${tabId}`}
                                                    index={index}
                                                    type="CALL_DETAILS_TAB"
                                                >
                                                    {(draggableProvided, draggableSnapshot) => (
                                                        <li
                                                            ref={draggableProvided.innerRef}
                                                            {...draggableProvided.draggableProps}
                                                            {...draggableProvided.dragHandleProps}
                                                            className={classnames("nav-item cd-tab-item", {
                                                                "cd-tab-item--dragging":
                                                                    draggableSnapshot.isDragging,
                                                            })}
                                                            style={draggableProvided.draggableProps.style}
                                                        >
                                                            <a
                                                                href="#/"
                                                                role="tab"
                                                                className={classnames("nav-link client-tab", {
                                                                    active: activeTab === tabId,
                                                                })}
                                                                onClick={(event) => {
                                                                    event.preventDefault();
                                                                    setActiveTab(tabId);
                                                                }}
                                                            >
                                                                {tabDefinition.label}
                                                            </a>
                                                        </li>
                                                    )}
                                                </Draggable>
                                            );
                                        })}
                                        {droppableProvided.placeholder}
                                    </ul>
                                )}
                            </Droppable>
                        </DragDropContext>

                        <TabContent activeTab={activeTab} className="p-3 p-md-4 cd-tab-content">
                            <TabPane tabId="1">
                                {callDetailsClientInfoLoading ? (
                                    <div className="text-muted py-4">Loading client information…</div>
                                ) : !callDetailsClientInfo ? (
                                    <div className="text-muted py-4">
                                        Client information could not be loaded.
                                    </div>
                                ) : (
                                    <Row className="g-4 client-info-cards cd-client-grid">
                                        {clientInfoDisplaySections.map(section => (
                                            <Col
                                                md="6"
                                                className="d-flex"
                                                key={section.title}
                                            >
                                                <div className="benefits-card w-100 cd-surface-card">
                                                    <h6 className="benefits-title">
                                                        {section.title}
                                                    </h6>
                                                    <div className="benefits-divider" />
                                                    {renderClientInfoSectionFields(
                                                        section.title,
                                                        section.fields
                                                    )}
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                )}


                            </TabPane>

                            <TabPane tabId="2" className="special-status-accordion">
                                <div className="cd-notes-tab">
                                    <Card className="border-0 shadow-sm rounded-3 cd-notes-card mb-0">
                                        <CardBody className="p-4">
                                            <Form onSubmit={handleCallNotesFormSubmit}>
                                                <h6 className="fw-bold mb-2">Special Notes</h6>
                                                <Input
                                                    type="textarea"
                                                    rows="3"
                                                    className="mb-3"
                                                    placeholder="Enter special notes..."
                                                    value={callNotesSpecialNotesInput}
                                                    onChange={(event) =>
                                                        setCallNotesSpecialNotesInput(event.target.value)
                                                    }
                                                />
                                                {/* {candidateDetails?.clientFeedback ? (
                                                    <div className="cd-client-feedback mb-4">
                                                        <h6 className="fw-bold mb-2">Client Feedback</h6>
                                                        <div className="cd-client-feedback__body text-break">
                                                            {candidateDetails?.clientFeedback}
                                                        </div>
                                                    </div>
                                                ) : null} */}

                                                <Row className="align-items-end gy-2">
                                                    {(() => {
                                                        const showScheduleDateTimeFields =
                                                            shouldShowCallNotesScheduleDateAndTimeFields(
                                                                callNotesSelectedStatusValue
                                                            );
                                                        const showCompletedDateFields =
                                                            shouldShowCallNotesDrugTestAndDotCompletionDateFields(
                                                                callNotesSelectedStatusValue
                                                            );
                                                        const showNotInterestedReasonField =
                                                            shouldShowCallNotesNotInterestedReasonDropdown(
                                                                callNotesSelectedStatusValue
                                                            );
                                                        const callStatusColumnMd =
                                                            showScheduleDateTimeFields ||
                                                                showCompletedDateFields ||
                                                                showNotInterestedReasonField
                                                                ? 6
                                                                : 12;
                                                        return (
                                                            <>
                                                                <Col md={callStatusColumnMd}>
                                                                    <Label className="fw-bold">
                                                                        Call Status <span className="text-danger">*</span>
                                                                    </Label>
                                                                    <Input
                                                                        type="select"
                                                                        className="mb-3"
                                                                        value={callNotesSelectedStatusValue}
                                                                        onChange={
                                                                            handleCallNotesCallStatusChange
                                                                        }
                                                                    >
                                                                        <option value="">Select Call Status</option>
                                                                        {callStatusDropdownOptions.map((dropdownOption) => (
                                                                            <option
                                                                                key={dropdownOption.value}
                                                                                value={dropdownOption.value}
                                                                            >
                                                                                {dropdownOption.label}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                </Col>

                                                                {showScheduleDateTimeFields ? (
                                                                    <Col md="6">
                                                                        <Label className="fw-bold">Schedule date and time</Label>
                                                                        <DatePicker
                                                                            selected={parseCallNotesScheduledDateTimeValue(
                                                                                callNotesScheduledDateTimeValue
                                                                            )}
                                                                            onChange={(date) =>
                                                                                setCallNotesScheduledDateTimeValue(
                                                                                    date
                                                                                        ? dayjs(date).format("YYYY-MM-DDTHH:mm")
                                                                                        : ""
                                                                                )
                                                                            }
                                                                            showTimeSelect
                                                                            timeIntervals={15}
                                                                            timeFormat="HH:mm"
                                                                            dateFormat="dd/MM/yyyy HH:mm"
                                                                            timeCaption="Time"
                                                                            customTimeInput={<CallNotesScheduleCustomTimeInput />}
                                                                            className="form-control mb-3 w-100"
                                                                            placeholderText="dd/mm/yyyy, HH:mm"
                                                                            popperPlacement="bottom-start"
                                                                            popperProps={{ strategy: "fixed" }}
                                                                        />
                                                                    </Col>
                                                                ) : null}

                                                                {showCompletedDateFields ? (
                                                                    <Col md="6">
                                                                        <Label className="fw-bold">
                                                                            Drug Test and DOT Completion Date{" "}
                                                                            <span className="text-danger">*</span>
                                                                        </Label>
                                                                        <Input
                                                                            type="date"
                                                                            className="mb-3"
                                                                            value={callNotesDrugTestAndDotCompletionDateValue}
                                                                            onChange={(event) =>
                                                                                setCallNotesDrugTestAndDotCompletionDateValue(
                                                                                    event.target.value
                                                                                )
                                                                            }
                                                                        />
                                                                    </Col>
                                                                ) : null}
                                                            </>
                                                        );
                                                    })()}

                                                    {shouldShowCallNotesNotInterestedReasonDropdown(
                                                        callNotesSelectedStatusValue
                                                    ) ? (
                                                        // <Row className="align-items-end">
                                                        <Col md="6">
                                                            <Label className="fw-bold">
                                                                Reason <span className="text-danger">*</span>
                                                            </Label>
                                                            <Select
                                                                options={notInterestedReasonDropdownOptions}
                                                                className="select2-selection mb-3"
                                                                placeholder="Select reason"
                                                                isClearable
                                                                isLoading={notInterestedReasonsLoading}
                                                                isDisabled={notInterestedReasonsLoading}
                                                                value={getSelectedOption(
                                                                    notInterestedReasonDropdownOptions,
                                                                    callNotesSelectedNotInterestedReasonId
                                                                )}
                                                                onChange={(option) =>
                                                                    setCallNotesSelectedNotInterestedReasonId(
                                                                        option?.value ?? ""
                                                                    )
                                                                }
                                                                menuPortalTarget={
                                                                    typeof document !== "undefined"
                                                                        ? document.body
                                                                        : null
                                                                }
                                                                styles={selectZIndexStyles}
                                                                menuPosition="fixed"
                                                            />
                                                        </Col>
                                                        // {/* </Row> */}
                                                    ) : null}
                                                </Row>



                                                <h6 className="fw-bold">Notes <span className="text-danger">*</span></h6>
                                                <Input
                                                    type="textarea"
                                                    rows="3"
                                                    className="mb-4"
                                                    value={callNotesContentInput}
                                                    onChange={(event) =>
                                                        setCallNotesContentInput(event.target.value)
                                                    }
                                                    placeholder="Enter notes..."
                                                />
                                                <div className="text-end mt-3">
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        disabled={callNotesFormSubmitInProgress}
                                                    >
                                                        {callNotesFormSubmitInProgress ? "Updating…" : "Update"}
                                                    </Button>
                                                </div>
                                            </Form>

                                            <h6 className="fw-bold mb-2 mt-4">Call Info</h6>
                                            {callActivitiesLoading ? (
                                                <div className="py-3">
                                                    <Loaders />
                                                </div>
                                            ) : (
                                                renderCallActivitiesAccordion({
                                                    activities: callInfoActivities,
                                                    accordionOpen: callNotesAccordionOpen,
                                                    toggleAccordion: toggleCallNotesAccordion,
                                                })
                                            )}

                                            {candidateResumeDownloadUrl ?
                                                <div
                                                    className={`cd-other-info-card${candidateResumeDownloadUrl
                                                            ? ""
                                                            : " cd-other-info-card--disabled"
                                                        }`}
                                                >
                                                    <div className="cd-other-info-card__icon-wrap" aria-hidden>
                                                        <i className="mdi mdi-file-document-outline" />
                                                    </div>
                                                    <div className="cd-other-info-card__body">
                                                        <span className="cd-other-info-card__title">
                                                            Candidate Resume
                                                        </span>
                                                        <span className="cd-other-info-card__desc">
                                                            {candidateResumeDownloadUrl
                                                                ? "Download the candidate's uploaded resume document."
                                                                : "No resume has been uploaded for this candidate yet."}
                                                        </span>
                                                        {/* {candidateResumeDownloadUrl ? (
                                                            <span
                                                                className="cd-other-info-card__filename"
                                                                title={candidateResumeFileName}
                                                            >
                                                                <i className="mdi mdi-paperclip" aria-hidden />
                                                                {candidateResumeFileName}
                                                            </span>
                                                        ) : null} */}
                                                    </div>
                                                    <div className="cd-other-info-card__action">
                                                        <Button
                                                            color="primary"
                                                            type="button"
                                                            className="cd-other-info-download-btn"
                                                            onClick={handleDownloadResumeClick}
                                                            disabled={!candidateResumeDownloadUrl}
                                                        >
                                                            <i className="mdi mdi-download me-1" aria-hidden="true" />
                                                            Download Resume
                                                        </Button>
                                                    </div>
                                                </div> : null
                                            }

                                            <h6 className="fw-bold mb-2 mt-4">Other Info</h6>
                                            {callActivitiesLoading ? (
                                                <div className="py-3">
                                                    <Loaders />
                                                </div>
                                            ) : otherClientActivityGroups.length === 0 ? (
                                                <p className="text-muted small mb-2">
                                                    No other client activity yet.
                                                </p>
                                            ) : (
                                                otherClientActivityGroups.map((clientGroup) => (
                                                    <div
                                                        key={
                                                            clientGroup.clientId ||
                                                            clientGroup.clientName
                                                        }
                                                        className="cd-other-info-client-group mb-3"
                                                    >
                                                        <p className="fw-semibold mb-2">
                                                            {clientGroup.clientName}
                                                        </p>
                                                        {renderCallActivitiesAccordion({
                                                            activities: clientGroup.activities,
                                                            accordionOpen: otherInfoAccordionOpen,
                                                            toggleAccordion: toggleOtherInfoAccordion,
                                                            idPrefix: `other-${clientGroup.clientId || clientGroup.clientName}`,
                                                            emptyMessage:
                                                                "No call activity for this client.",
                                                        })}
                                                    </div>
                                                ))
                                            )}
                                        </CardBody>
                                    </Card>
                                </div>
                            </TabPane>

                            <TabPane tabId="3" className="special-status-accordion">
                                <div className="cd-notes-tab">
                                    <Card className="border-0 shadow-sm rounded-3 cd-notes-card mb-0">
                                        <CardBody className="p-4">
                                            <h6 className="fw-bold mb-2">AI Transcripts</h6>
                                            {callActivitiesLoading ? (
                                                <div className="py-3">
                                                    <Loaders />
                                                </div>
                                            ) : aiTranscriptActivities.length === 0 ? (
                                                <div className="cd-empty-state text-center py-5 px-3">
                                                    <div className="cd-empty-icon mx-auto mb-3" aria-hidden>
                                                        <i className="mdi mdi-text-box-search-outline" />
                                                    </div>
                                                    <h6 className="fw-semibold mb-1">No AI transcripts yet</h6>
                                                    <p className="text-muted small mb-0 mx-auto cd-empty-copy">
                                                        Transcripts will appear here when generated for this call.
                                                    </p>
                                                </div>
                                            ) : (
                                                <Accordion
                                                    open={aiTranscriptAccordionOpen}
                                                    toggle={toggleAiTranscriptAccordion}
                                                >
                                                    {aiTranscriptActivities.map((callActivityRecord) => {
                                                        const callActivityAccordionTargetId =
                                                            getCallActivityAccordionTargetId(callActivityRecord);
                                                        const transcriptBtnId = `cd-ai-transcript-btn-${callActivityAccordionTargetId}`;
                                                        return (
                                                            <AccordionItem
                                                                key={callActivityAccordionTargetId}
                                                                className="mt-1"
                                                            >
                                                                <AccordionHeader
                                                                    targetId={callActivityAccordionTargetId}
                                                                >
                                                                    <div className="d-flex w-100 align-items-center justify-content-between gap-2 pe-1">
                                                                        <div className="d-flex flex-wrap align-items-center gap-2">
                                                                            <strong>
                                                                                {formatCallActivityDateTime(
                                                                                    callActivityRecord?.callDate
                                                                                )}
                                                                            </strong>
                                                                            <Badge
                                                                                color={callStatusTypeBadgeColor(
                                                                                    callActivityRecord?.callStatusType
                                                                                )}
                                                                                className="badge-padding text-capitalize"
                                                                            >
                                                                                {humanizeCallStatusType(
                                                                                    callActivityRecord?.callStatusType
                                                                                )}
                                                                            </Badge>
                                                                            <span className="text-muted">Submitted By</span>
                                                                            <span>
                                                                                {displayText(
                                                                                    callActivityRecord?.callByName
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="cd-ai-transcript-btn-wrap flex-shrink-0">
                                                                            <Button
                                                                                id={transcriptBtnId}
                                                                                color="primary"
                                                                                className="w-70 cd-ai-transcript-open-btn d-inline-flex align-items-center justify-content-center gap-1"
                                                                                type="button"
                                                                                onClick={(event) => {
                                                                                    event.stopPropagation();
                                                                                    handleOpenAiTranscriptModal(
                                                                                        callActivityRecord
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="mdi mdi-text-box-outline"
                                                                                    aria-hidden
                                                                                />
                                                                                AI Transcript
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </AccordionHeader>

                                                                <AccordionBody
                                                                    accordionId={callActivityAccordionTargetId}
                                                                >
                                                                    {renderCallActivityBody(callActivityRecord)}
                                                                </AccordionBody>
                                                            </AccordionItem>
                                                        );
                                                    })}
                                                </Accordion>
                                            )}
                                        </CardBody>
                                    </Card>
                                </div>
                            </TabPane>
                        </TabContent>

                    </CardBody>
                </Card>

                <Modal
                    isOpen={aiTranscriptModal.open}
                    toggle={closeAiTranscriptModal}
                    size="lg"
                    className="modal-full-height"
                    centered
                >
                    <ModalHeader toggle={closeAiTranscriptModal}>Call transcript</ModalHeader>
                    <ModalBody className="ai-recruiter-transcript-modal-body">
                        {aiTranscriptModal.loading ? (
                            <div className="py-4">
                                <Loaders />
                            </div>
                        ) : aiTranscriptModalMessages.length ? (
                            <div className="ai-recruiter-transcript-chat">
                                {aiTranscriptModalMessages.map((msg) => (
                                    <div
                                        key={msg.id}
                                        className={`ai-recruiter-chat-row ai-recruiter-chat-row--${msg.role}`}
                                    >
                                        <div
                                            className={`ai-recruiter-chat-avatar ai-recruiter-chat-avatar--${msg.role}`}
                                            aria-hidden
                                        >
                                            {msg.role === "user" ? (
                                                <img
                                                    src={defaultChatUserAvatarSrc}
                                                    alt=""
                                                    width={38}
                                                    height={38}
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                            ) : (
                                                <i className="mdi mdi-robot-outline" aria-hidden />
                                            )}
                                        </div>
                                        <div className="ai-recruiter-chat-main">
                                            <div className="ai-recruiter-chat-bubble">
                                                <div
                                                    className={`ai-recruiter-sender-label ai-recruiter-sender-label--${msg.role}`}
                                                    aria-label={
                                                        msg.role === "user"
                                                            ? "Message sent by candidate"
                                                            : "Message sent by AI recruiter"
                                                    }
                                                >
                                                    <span className="ai-recruiter-sender-dot" aria-hidden />
                                                    <span className="ai-recruiter-sender-text">
                                                        {msg.senderLabel ??
                                                            (msg.role === "user" ? "Candidate" : "AI Recruiter")}
                                                    </span>
                                                </div>
                                                <div>{msg.message}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <pre
                                className="mb-0 p-3 rounded border bg-light small"
                                style={{
                                    maxHeight: "70vh",
                                    overflow: "auto",
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {aiTranscriptModalBody || "No transcript available for this call."}
                            </pre>
                        )}
                    </ModalBody>
                </Modal>

                <DrivingExperienceModal
                    isOpen={drivingExpModalOpen}
                    toggle={() => setDrivingExpModalOpen(false)}
                    candidateListRowOrDetailsItem={candidateDetails}
                    workExperiencePathCandidateIdFallback={id}
                    onClose={(drivingExperienceModalSavedSuccessfully, hadExistingDrivingExperienceRows) => {
                        if (drivingExperienceModalSavedSuccessfully) {
                            setDrivingExpDefaultChecked(true);
                            setDrivingExpCheckboxKey(
                                (previousDrivingExperienceCheckboxKey) =>
                                    previousDrivingExperienceCheckboxKey + 1
                            );
                        } else if (
                            pendingDrivingExpOpenRef.current &&
                            !hadExistingDrivingExperienceRows
                        ) {
                            setDrivingExpDefaultChecked(false);
                            setDrivingExpCheckboxKey(
                                (previousDrivingExperienceCheckboxKey) =>
                                    previousDrivingExperienceCheckboxKey + 1
                            );
                        }
                        pendingDrivingExpOpenRef.current = false;
                    }}
                    setIsDriverExperience={setIsDriverExperience}
                />

                <FedexExistingDriverModal
                    isOpen={fedexModalOpen}
                    toggle={() => setFedexModalOpen(false)}
                    candidateId={id}
                    candidateClientId={candidateDetails?.id}
                    onClose={(fedexModalSaveSucceeded, hadExistingFedexRowsWhenModalOpened) => {
                        if (fedexModalSaveSucceeded) {
                            setFedexDefaultChecked(true);
                            setFedexCheckboxKey(
                                (previousFedexCheckboxKey) => previousFedexCheckboxKey + 1
                            );
                        } else if (
                            pendingFedexOpenRef.current &&
                            !hadExistingFedexRowsWhenModalOpened
                        ) {
                            setFedexDefaultChecked(false);
                            setFedexCheckboxKey(
                                (previousFedexCheckboxKey) => previousFedexCheckboxKey + 1
                            );
                        }
                        pendingFedexOpenRef.current = false;
                    }}
                    setIsExistingFedexDriver={setIsExistingFedexDriver}
                />

                <DriverDetailsModal
                    isOpen={isDriverDetailsModalOpen}
                    onClose={handleDriverDetailsModalClose}
                    candidateId={
                        isDriverDetailsModalOpen
                            ? String(
                                candidateTestActionBodyCandidateClientId ||
                                candidateDetails?.id ||
                                id ||
                                ""
                            ).trim() || null
                            : null
                    }
                    candidateClientId={
                        isDriverDetailsModalOpen
                            ? String(
                                candidateTestActionBodyCandidateClientId ||
                                candidateDetails?.id ||
                                id ||
                                ""
                            ).trim()
                            : ""
                    }
                    onSuccess={handleDriverDetailsSavedRefreshCallDetailsPage}
                />

                <PreScreeningModal
                    setPreScreeningModalOpen={setIsPreScreeningModalOpen}
                    preScreeningModalOpen={(toolbarData && toolbarData?.showPreScreening)? isPreScreeningModalOpen : false}
                    candidateClientId={
                        isPreScreeningModalOpen ? preScreeningCandidateClientId : ""
                    }
                    getCallDetailsPageData={() => {
                        if (id) {
                            fetchCandidateDetails(id);
                        }
                    }}
                />

                <CallDetailsBadFitResolutionModal
                    isOpen={
                        Boolean(toolbarData?.showBadFitResolution) && isBadFitResolutionModalOpen
                    }
                    onClose={() => setIsBadFitResolutionModalOpen(false)}
                    candidateClientId={String(
                        toolbarCandidateClientId || preScreeningCandidateClientId || id || ""
                    ).trim()}
                    badFitTrackingId={toolbarData?.badFitTrackingId ?? null}
                    onSuccess={handleBadFitResolutionSuccess}
                />

                <MessageModal
                    messageRef={messageRef}
                    messageModalOpenClose={messageModalOpenClose}
                    setMessageModalOpenClose={handleCloseConversationModal}
                    messages={conversationMessages}
                    loading={conversationLoading}
                    callDetailsId={id}
                    templates={conversationTemplates}
                    onConversationRefresh={reloadConversationMessages}
                    candidateDetails={candidateDetails}
                />

                <CallDetailsAiCallScheduledModal
                    isOpen={aiCallScheduledModalOpen}
                    onClose={handleCloseAiCallScheduledModal}
                    loading={aiCallScheduledLoading}
                    rows={aiCallScheduledRows}
                    candidateName={aiCallScheduledCandidateName}
                />

                <CallDetailsAiCallRequestModal
                    isOpen={aiCallRequestModalOpen}
                    onClose={handleCloseAiCallRequestModal}
                    onConfirm={handleConfirmAiCallRequest}
                    submitting={aiCallRequestSubmitting}
                    candidateName={aiCallScheduledCandidateName}
                    candidateClientId={resolveAiRecruiterCandidateClientId()}
                />

                <CallDetailsAiRecruiterOptOutModal
                    isOpen={aiRecruiterOptOutModalOpen}
                    onClose={() => setAiRecruiterOptOutModalOpen(false)}
                    candidateClientId={resolveAiRecruiterCandidateClientId()}
                    onSuccess={handleAiRecruiterOptOutSuccess}
                />

                {/* <ImagePreviewModal
                    imagePreviewModalOpenClose={imagePreviewModalOpenClose}
                    setImagePreviewModalOpenClose={setImagePreviewModalOpenClose}
                /> */}
            </Container>
        </div>
    );
};

export default CallDetails;
